export default {
  date: {
    formats: {
      default: '%d-%m-%Y',
      short: '%-d %B',
      long: '%-d %B, %Y',
      with_day: '%A, %-d %B %Y',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'söndag',
      'måndag',
      'tisdag',
      'onsdag',
      'torsdag',
      'fredag',
      'lördag',
    ],
    abbr_day_names: ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'],
    month_names: [
      null,
      'januari',
      'februari',
      'mars',
      'april',
      'maj',
      'juni',
      'juli',
      'augusti',
      'september',
      'oktober',
      'november',
      'december',
    ],
    abbr_month_names: [
      null,
      'jan',
      'feb',
      'mar',
      'apr',
      'may',
      'jun',
      'jul',
      'aug',
      'sep',
      'okt',
      'nov',
      'dec',
    ],
    order: [':år', ':månad', ':dag'],
  },
  number: {
    format: {
      separator: '.',
      delimiter: ',',
      precision: 3,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%u%n',
        unit: '$',
        separator: '.',
        delimiter: ',',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'cad',
      AUD: 'aud',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: null,
        format: '%n%',
      },
    },
    precision: {
      format: {
        delimiter: null,
      },
    },
    human: {
      format: {
        delimiter: null,
        precision: 3,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: 'B',
          kb: 'kB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: null,
          thousand: 'tusen',
          million: 'miljon',
          billion: 'miljard',
          trillion: 'triljon',
          quadrillion: 'kvadriljon',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'en halv minut',
      less_than_x_seconds: {
        one: 'mindre än 1 sekund',
        other: 'mindre än %{count} sekunder',
        few: 'less than %{count} seconds',
        many: 'less than %{count} seconds',
      },
      x_seconds: {
        one: '1 sekund',
        other: '%{count} sekunder',
        few: '%{count} seconds',
        many: '%{count} seconds',
      },
      less_than_x_minutes: {
        one: 'mindre än 1 minut',
        other: 'mindre än %{count} minuter',
        few: 'less than %{count} minutes',
        many: 'less than %{count} minutes',
      },
      x_minutes: {
        one: '1 minut',
        other: '%{count} minuter',
        few: '%{count} minutes',
        many: '%{count} minutes',
      },
      about_x_hours: {
        one: 'ungefär 1 timme',
        other: 'ungefär %{count} timmar',
        few: 'about %{count} hours',
        many: 'about %{count} hours',
      },
      x_days: {
        one: '1 dag',
        other: '%{count} dagar',
        few: '%{count} days',
        many: '%{count} days',
      },
      about_x_months: {
        one: 'ungefär 1 månad',
        other: 'ungefär %{count} månader',
        few: 'about %{count} months',
        many: 'about %{count} months',
      },
      x_months: {
        one: '1 månad',
        other: '%{count} månader',
        few: '%{count} months',
        many: '%{count} months',
      },
      about_x_years: {
        one: 'ungefär 1 år',
        other: 'ungefär %{count} år',
        few: 'about %{count} years',
        many: 'about %{count} years',
      },
      over_x_years: {
        one: 'över 1 år',
        other: 'över %{count} år',
        few: 'over %{count} years',
        many: 'over %{count} years',
      },
      almost_x_years: {
        one: 'nästan 1 år',
        other: 'nästan %{count} år',
        few: 'almost %{count} years',
        many: 'almost %{count} years',
      },
      x_years: {
        one: 'ett år',
        other: '%{count} år',
      },
      x_weeks: {
        one: '1 vecka',
        other: '%{count} veckor',
        few: '%{count} weeks',
        many: '%{count} weeks',
      },
      x_hours: {
        one: '1 timme',
        other: '%{count} timmar',
      },
    },
    prompts: {
      year: 'år',
      month: 'månad',
      day: 'dag',
      hour: 'timme',
      minute: 'minut',
      second: 'sekunder',
    },
  },
  page: {
    plus: {
      button: {
        text: 'Uppgradera till Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Upp till fem olika bilder',
        best_2: 'JPEG eller PNG',
        best_3: 'Upp tilll %{size}',
        best_4: '%{resolution} pixlar eller mer',
        best_5: 'Inga GIF-filer eller videor (tyvärr)',
        best_title: 'Det viktiga:',
        text: 'Placera dig själv eller ditt varumärke i centrum med upp till fem roterande videor eller bilder:',
        best_five: '%{videoResolution} pixlar för videor',
        best_four: '%{resolution} pixlar för bilder',
        best_one: 'Upp till fem videor eller bilder',
        best_six:
          'Bakgrundsbilder roteras var %{rotationInterval} sekund och videor som är längre än %{rotationInterval} sekunder kommer att klippas ner',
        best_three: 'Max %{size} per video/bild',
        best_two: 'JPEG, PNG eller MP4',
        notice:
          "Trumvirvel, tack – videobakgrunder gör entré! <a href='/profile'>Lägg till en video som bakgrund nu</a> .",
      },
      upsell: {
        benefit_one_alt: 'Skaffa dig en egen WeTransfer-sida',
        heading_alt: 'Leverera ditt arbete med stil',
        benefit_one: 'Få ditt eget WeTransfer-domännamn',
        benefit_three: 'Designa dina överföringsmejl',
        benefit_two:
          'Visa anpassade bakgrundsbilder när någon hämtar dina filer',
        button: {
          action: 'Berätta mer',
        },
        heading: 'Visa upp ditt varumärke med WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Send the best.</strong> Make a great impression every time people download your files.<br /> <strong>Receive with ease.</strong> Anyone can upload files to you as part of your plan.',
        protip: {
          text: '<strong>Pro tip:</strong> Requesting a transfer from someone? Share a special link to pre-fill the description for them.',
          link: 'Learn more',
        },
      },
      pagename: 'Profilinställningar',
      'onboarding-step-two':
        "Skicka dina filer i ett prydligt paket. Skräddarsy din WeTransfer-profil och beundra din nya look på <a href='%{href}'>%{domain}</a>.",
      email_backgrounds: 'Bakgrundsbilder till e-postmeddelanden',
      sent_you_files: 'har skickat några filer till dig',
      email_background_instruction_with_spec:
        'Få dina överföringsmeddelanden att stå ut från mängden genom att lägga till en bakgrundsbild.   \nLadda upp en bild på %{resolution} pixlar för bästa möjliga resultat (observera att vi måste beskära bilder som är större än detta). Maximal filstorlek är %{size}.',
      receiving: 'Mejl för profil',
      choose_wallpapers: 'Bakgrundsbilder',
      'step-one-banner':
        'Kom igång genom att välja en URL för din WeTransfer-sida. Du kan ändra din URL senare.',
      description: {
        pro: 'Din WeTransfer-sida låter dig göra ett gott intryck varje gång dina filer hämtas. På din sida kan vem som helst skicka överföringar på 200 GB som en del av ditt WeTransfer Pro-paket.',
        premium:
          'Din WeTransfer-sida låter dig göra ett gott intryck varje gång dina filer hämtas. På din sida kan andra skicka överföringar till dig, utan begränsning av filstorlek, som en del av ditt WeTransfer Premium-paket.',
      },
      'instructions-1': 'Ändra namn och URL så många gånger du vill.',
      'instructions-2': 'När du har valt en ny URL uppdateras din sida direkt.',
      title: 'Redigera din sida',
      profile_url: 'URL till profil',
    },
    payment: {
      never_actived_retry:
        'Ditt konto är inte aktivt ännu. Slutför din registrering för att komma igång med <a href="/payment/retry">%{planName}</a>.',
      pagename: 'Paket och betalning',
      autorenew_heading: 'Betalningsuppgifter',
      autorenew_notice:
        'Din %{planName}-prenumeration på %{deal} förlängs automatiskt den %{autorenewal_attempt}.',
      will_expire_notice:
        "Din Pro-prenumeration <span class='payment__notice'>upphör om %{daysBetween} dagar</span>. Förläng din prenumeration nu eller ställ in automatisk förlängning.",
      never_actived_notice:
        'Ditt konto är inte aktivt än. <a href="/payment/retry">Avsluta din registrering för att komma igång med Pro.</a>',
      manual_renewal_expiry_notice: 'Ditt Pro-konto upphör den %{expiry}.',
      to_checkout: 'Gå till kassan',
      updating: 'Uppdaterar …',
      yes_disable: 'Ja, fortsätt',
      review_billing_link: 'Vill du uppdatera din betalningsmetod?',
      autorenew_failed:
        "Din Pro-prenumeration för %{deal}/%{period} <span class='payment__notice'><strong>upphör om %{daysBetween} dagar</strong>. Vi kunde inte förlänga din prenumeration åt dig. Du måste göra det manuellt innan <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Är du säker på att du vill stoppa automatisk förlängning?',
      disable_autorenewal: 'Stoppa automatisk förlängning',
      enable_autorenewal: 'Aktivera automatisk förlängning',
      renew_now: 'Förläng nu',
      subscription_expired: 'Din Pro-prenumeration har upphört.',
      cancel_heading: 'Dags att gå vidare?',
      cancel_info:
        'Vi förstår. Det är sådant som händer. När du avslutar din prenumeration behåller vi dina filer i 30 dagar (nej, inte under kudden – du behöver inte göra här det jobbigare än det är) ifall du skulle ha glömt något. Du kan också starta din prenumeration igen när du vill.',
      cancel_info_subscription:
        'Vi förstår. Det är sådant som händer. När du avslutar din prenumeration kan du använda ditt Pro-konto till och med %{subscriptionExpiryDate}. Efter det behåller vi dina filer i 30 dagar (nej, inte under kudden – du behöver inte göra det här jobbigare än det är) ifall du skulle ha glömt något. Du kan också starta din prenumeration igen när du vill.',
      cancel_now: 'Avsluta prenumeration',
      cancelling: 'Avslutar …',
      confirm_cancel_subscription:
        'Är du säker på att du vill avsluta din prenumeration?',
      confirm_reactivate_subscription:
        'Ett utmärkt val! Bara ett klick till för att återaktivera din betalningsmetod',
      manual_renewal_in_future_notice:
        'Din Pro-prenumeration för %{deal}/%{period} upphör om %{daysBetween} dagar. Du kan förlänga din prenumeration efter %{manual_renewal_available_at} eller aktivera automatisk förlängning nu.',
      reactivate_heading: 'Låt oss börja om.',
      reactivate_content_top_pro:
        'Du kan återaktivera din prenumeration på %{planName} – då blir det som om du aldrig hade avslutat den. Eller så kan du välja att uppgradera till WeTransfer Premium:',
      reactivate_content_top_premium:
        'Du kan återaktivera din prenumeration på %{planName} – då blir det som om du aldrig hade avslutat den.',
      reactivate_content_bottom_pro:
        'Om du uppgraderar till Premium blir du debiterad %{upfront_payment} och kan komma igång med WeTransfer Premium direkt. Din nya prenumeration för %{recurring_payment}/%{interval} kommer att förnyas den %{recurring_date}.',
      reactivate_pro: 'Återaktivera Pro',
      reactivate_premium: 'Återaktivera Premium',
      reactivate_upgrade_to_premium: 'Uppgradera till Premium',
      reactivating: 'Återaktiverar …',
      subscription_cancelled:
        'Din prenumeration har annullerats och kommer automatiskt att upphöra om %{daysBetween} dagar.',
      subscription_reactivate_expired_notice: 'Ditt Pro-konto har avbrutits.',
      subscription_reactivate_notice_pro:
        'Din prenumeration på %{planName} har avslutats och upphör om %{daysBetween} dagar.',
      subscription_reactivate_notice_premium:
        'Din prenumeration på %{planName} har avslutats och upphör om %{daysBetween} dagar.\nHar du ändrat dig? Ingen panik, det är enkelt att komma igång igen.',
      subscription_reactivate_notice_trial_before:
        'Din prenumeration på %{planName} har avslutats och upphör om %{daysBetween} dagar.\nDu kan fortsätta att utnyttja ditt prov på WeTransfer Premium fram till att prenumerationen upphör.',
      subscription_reactivate_notice_trial_after:
        'Din prenumeration på %{planName} har avslutats och upphör om %{daysBetween} dagar.\nDu kan fortsätta att utnyttja ditt prov på WeTransfer Premium fram till den %{trialExpiryDate}.',
      update_method_link: 'Uppdatera betalningsuppgifter',
      autorenew_notice_teams:
        'Den %{autorenewal_attempt} kommer din %{planName}-prenumeration på %{deal} att förnyas automatiskt för ditt team på %{number_of_members} medlemmar.',
      cancellation_cta: 'Avsluta prenumeration',
      cancellation_heading:
        'Behöver du inte längre fördelarna med %{planName}?',
      cancellation_heading_trial: 'Avsluta prenumeration',
      cancellation_text:
        'Om du avslutar din prenumeration kan du använda Pro-funktionerna till och med %{subscriptionExpiryDate}. Därefter kommer ditt WeTransfer Pro-konto att övergå i ett gratiskonto och dina befintliga överföringar kommer att bli otillgängliga 28 dagar senare.',
      cancellation_text_item_1: 'Skicka upp till %{transfer_limit}',
      cancellation_text_item_2: 'Lösenordsskydda överföringar',
      cancellation_text_item_3:
        'Hantera och lagra överföringar på upp till totalt %{storage_limit}',
      cancellation_text_item_4: 'Ha din egen URL och anpassade Pro-sida',
      cancellation_text_item_heading:
        'Med ett gratiskonto kan du bara skicka %{free_size_limit} per överföring. Du kan inte längre:',
      cancellation_text_new:
        'Om du avslutar din prenumeration nu kan du använda %{planName} fram till den %{subscriptionExpiryDate}. Därefter kommer du att nedgraderas till ett gratispaket.<br /><br />Bara så att du vet går eventuella befintliga överföringar ut senast 28 dagar efter att prenumerationen upphör.',
      cancellation_text_teams:
        'Om du avslutar din prenumeration nu kan du och ditt team använda %{planName} fram till den %{subscriptionExpiryDate}.<br /><br />Därefter kommer du och dina teammedlemmar inte längre att kunna skicka filöverföringar, skapa presentationsbilder och sätta ihop boards tillsammans. Du kommer att nedgraderas till ett gratispaket och kommer bara att kunna logga in på ditt eget WeTransfer-konto.<br /><br />Bara så att du vet går eventuella befintliga överföringar ut senast 28 dagar efter att prenumerationen upphör.',
      premium_trial: {
        feature_list_item_1: 'Inga storleksbegränsningar på överföringar',
      },
      premium_upgrade: {
        cta: 'Byt till Premium',
        description:
          'Du kommer att debiteras %{upfront_payment} och du kommer att kunna komma igång med WeTransfer Premium direkt. Din nya prenumeration på %{recurring_payment} / %{interval} kommer att förnyas den %{recurring_date}.',
        feature_list_item_1: 'Skicka överföringar utan storleksbegränsningar',
        feature_list_item_2: 'Obegränsade lagringsmöjligheter',
        feature_list_item_3: 'Obegränsade portals och granskningar',
        feature_list_item_4: '%{storageLimit} lagringsutrymme',
        heading: 'Vill du uppgradera ditt paket?',
      },
      unpaid_invoices: {
        heading: 'Du har obetalda fakturor',
        item: {
          issued_on: 'Utfärdad den',
          pay_invoice: 'Betala faktura',
          pending_invoice: 'Väntar …',
        },
        subheading:
          'Det verkar ha varit problem med dina tidigare betalningar. Betala eventuella utestående fakturor, annars kan din Pro-prenumeration komma att avslutas.',
        subheading_2:
          'Om du har väntande fakturor kan du bara avvakta – vi försöker igen om ett par dagar, och så fort betalningen har genomförts är allt som det ska.',
      },
      upgrade_cta: 'Uppgradera',
      app_subscription_banner: {
        title: 'Du prenumererar genom %{app_name}',
        content:
          'För att visa eller hantera din prenumeration loggar du in på ditt %{app_name}-konto från din telefon eller dator.',
        go_to: 'Gå till',
        learn_more: 'Läs mer',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Avsluta prenumeration',
      cancellation_disclaimer:
        '* Bara så att du har koll: Dina befintliga överföringar blir otillgängliga 28 dagar efter att du nedgraderar ditt konto.',
      'current-plan': 'Nuvarande paket',
      'free-forever': 'Gratis för alltid',
      'free-usp-1': 'Skicka upp till 2 GB',
      'free-usp-2': 'Inget lagringsutrymme',
      'free-usp-3': 'Överföringar är tillgängliga i 7 dagar*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'Om du avslutar din prenumeration nu kan du fortsätta att använda WeTransfer Pro till och med <b>%{expiration_date}</b>. Därefter kommer du att nedgraderas till ett gratis WeTransfer-konto – som också är rätt så fantastiskt.',
      pagename: 'Behöver du inte längre fördelarna med Pro?',
      'pro-usp-1': 'Skicka och ta emot upp till %{transfer_limit}',
      'pro-usp-2': '1 TB lagringsutrymme',
      'pro-usp-3': 'Bestäm hur länge överföringar ska vara tillgängliga',
      'pro-usp-4':
        '<p>Din egen <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">Pro-sida</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Få tillgång till Paste® Pro och Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Du har nu avslutat din prenumeration och kommer att nedgraderas till ett gratis WeTransfer-konto efter <b>%{ends_at}.</b></p> \n<p>Berätta varför du lämnar oss så att vi kan förbättra WeTransfer med dig i åtanke.</p>',
      reason_header: 'Synd att du lämnar oss',
      cancel: 'Gå tillbaka',
      info: 'Berätta varför du lämnar oss så kommer vi att förbättra WeTransfer Pro med dig i åtanke.',
      pagename: 'Innan du lämnar oss',
      yes_disable: 'Ja, fortsätt',
    },
    payment_failed: {
      selected_product: '1 %{duration} med %{planTier}',
      change: 'Uppdatera',
      complete_order: 'Slutför din beställning',
      description: 'Granska dina uppgifter och slutför din beställning',
      description_error:
        'Något gick snett. Granska dina uppgifter och fortsätt till kassan.',
      description_refused:
        'Vi kunde inte behandla din betalning. Kontrollera din betalningsinformation och försök igen.',
      discount: 'Rabatt',
      product_description: 'En %{duration} med WeTransfer Pro',
      title: 'Du är nästan klar!',
      total: 'Totalt',
      vat: 'Moms',
      your_details: 'Dina uppgifter',
      your_order: 'Din beställning',
      title_error: 'Hm, något verkar ha gått fel',
      title_refused: 'Hm, något verkar ha gått fel',
      payment_status_message:
        'Din betalning har genomförts, men det har inträffat ett fel som gör att vi inte kan uppdatera ditt paket automatiskt. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Kontakta supporten</a>',
    },
    payment_methods: {
      billed_now: 'Fakturerat nu',
      info_content: {
        cancel_bullet:
          'Oroa dig inte. Du kan avbryta prenumerationen under Kontoinställningar > Betalningar.',
        initial_payment_bullet:
          'Efter den första betalningen kommer du debiteras %{price} %{interval} (såvida du inte bestämmer dig för att säga upp din prenumeration – men det skulle du väl inte göra, eller hur?)',
        update_payment_bullet:
          'Du kan alltid uppdatera dina betalningsuppgifter och/eller faktureringsinformation innan din nästa betalning ska vara gjord.',
        month:
          '– Efter din första betalning blir du debiterad %{price} varje månad (om du inte avslutar din Pro-prenumeration – men varför skulle du göra det?) \n– Var inte orolig – alternativet för att avsluta finns under Kontoinställningar > Betalning.– Du kan alltid uppdatera din betalningsmetod och/eller din företagsinformation innan nästa betalning förfaller.',
        year: '– Efter den första betalningen kommer du att debiteras %{price} per år. (Om du inte bestämmer dig för att avbryta din Pro-prenumeration. Men det gör du väl inte? Eller?!)\n– Oroa dig inte. Du kan avbryta prenumerationen under Kontoinställningar > Betalningar.\n– Du kan alltid uppdatera din betalningsmetod och/eller din företagsinformation innan nästa betalning förfaller.',
      },
      payment_cta: 'Gör klart betalning',
      payment_term: {
        monthly: 'en gång per månad',
        yearly: 'en gång per år',
      },
      payment_title: 'Betalning',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Per månad',
        year: 'Per år',
      },
      subtotal: 'Delsumma',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Din betalningsmetod',
      bancontact: 'Bancontact',
      card: 'Betalkort',
      card_cvc: 'CVC',
      card_expiration: 'MM/ÅÅ',
      card_name: 'Namn som står på kortet',
      card_number: 'Kortnummer',
      complete_payment: 'Slutför betalning',
      creditcard: 'Betalkort',
      discount: 'Rabatt',
      do_not_refresh: 'Uppdatera eller stäng inte sidan',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL är en onlinebetaltjänst från Nederländerna som låter kunderna använda sin egen bank för att genomföra betalningen.',
      info: 'Uppdatera betalningsmetod',
      payment_in_progress: 'Din betalning behandlas …',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/månad',
        year: '/år',
      },
      select_bank: 'Välj din bank',
      select_country: 'Välj land',
      sofort: 'SOFORT',
      tax: 'Moms',
      title: 'Välj betalningsmetod',
      total: 'Totalt',
    },
    projects: {
      actions: {
        go_back: 'Alla projekt',
        discard: 'Ta bort ändringar',
        edit: 'Redigera',
        remove_transfer:
          'Vill du radera överföringen? Filerna kommer att tas bort från projektet och skickade överföringar.',
        save: 'Spara',
        share: 'Dela',
      },
      transfer_actions: {
        download: 'Hämta',
      },
      added_at: 'kl. %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Kopiera länk',
        link_copied: 'Länken kopierad till urklipp',
        content_label: 'Kopiera länken till projektet',
        list_item_1: 'Endast hämtnings- och visningsbehörighet',
        list_item_2: 'Länken förblir densamma för alltid',
        title: 'Dela projekt',
      },
      content: {
        empty_state:
          'Ditt projekt är för närvarande tomt. Kom igång genom att lägga till några filer och starta projektets tidslinje.',
      },
      logo_title: 'Tillbaka till wetransfer.com',
      logo_tooltip_caption: 'Tillbaka till WeTransfer',
      timestamp: 'För %{timeAgo} sedan',
      chat: {
        owner_button_label: 'Psst … prata med oss',
        owner_offline_greeting:
          'Vi är just nu offline, men om du berättar vad du har problem med så hör vi av oss till dig inom en arbetsdag.',
        owner_online_greeting:
          'Berätta vad du har problem med, så hör vi av oss till dig så snart som möjligt',
        receiver_button_label: 'Frågor? Vi hjälper dig gärna',
        receiver_offline_greeting:
          'Berätta vad du har problem med, så hör vi av oss till dig så snart som möjligt.',
        receiver_online_greeting:
          'Berätta vad du har problem med, så hör vi av oss till dig så snart som möjligt.',
      },
      created_by: 'Skapad av %{user}',
      created_by_fallback: 'Skapad',
      deliverable_clipboard_modal: {
        content_label: 'Kopiera länk till leveransen',
        info: 'Andra kommer även att kunna se ditt projekt',
        title: 'Dela leverans',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'Det här är inte det projekt som du letar efter …',
        limit: 'Du har obegränsad potential, men har nått teckengränsen',
        required: 'Du vet hur det går till. Det här måste du fylla i.',
      },
      event: {
        project_created_byline:
          'Lägg till några filer för att visa vad du jobbar med.',
        project_created_title: 'Projektets start',
      },
      file_count: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      just_now: 'nyss',
      labels: {
        description: 'Beskrivning',
        name: 'Namn',
        new_name: 'Namnge ditt projekt',
      },
      logo: {
        cta: 'Lägg till en logotyp',
        errors: {
          dimensions:
            'Din logotyp är mindre än 220 × 220 px. Prova med en större bild.',
          general: 'Hmm, något gick snett. Försök igen.',
          size: 'Din logotyp är större än 5 MB. Prova med en mindre fil.',
          type: 'Din logotyp är inte en JPEG-, GIF- eller PNG-fil. Prova med en annan bild.',
        },
        instructions:
          'Din logotyp kan vara upp till 5 MB. JPEG och GIF är okej, men PNG med transparent bakgrund är allra bäst.',
        'instructions-title': 'Visa upp ditt varumärke',
      },
      name_modal: {
        content_label: 'Namnge eller byt namn på ditt projekt',
        input_placeholder_0: 'Definitivt ett Cannes-lejon',
        input_placeholder_1: 'Ett botemedel mot förkylning',
        input_placeholder_2: 'Det perfekta brottet',
        input_placeholder_3: 'Jag skriver låtar, inte titlar',
        input_placeholder_4: 'En enastående idé',
        input_placeholder_5: 'En helt ny varumärkeskampanj',
        input_placeholder_6: 'Världsherravälde',
        save: 'Spara',
        text: 'Beskriv vad du jobbar med.',
        title: 'Namnge ditt projekt',
      },
      new_project_label: 'Starta ett nytt projekt',
      noticebar: {
        'button-cancel': 'Avbryt',
        'button-clear-all-files': 'Rensa alla',
        'button-close': 'Stäng',
        'button-delete': 'Radera',
        'button-no': 'Nej',
        'button-share': 'Dela',
        'button-yes': 'Ja',
        'confirm-cancel': 'Vill du avbryta överföringen?',
        'confirm-clear-files-deliverable':
          'Vill du rensa alla filer från <strong><u>%{deliverableName}</u></strong>?',
        'confirm-complete':
          'Uppladdningen är klar! Berätta för alla att du har lagt till fler filer.',
        'confirm-delete-deliverable':
          'Vill du radera <strong><u>%{deliverableName}</u></strong> och alla filer som du har laddat upp dit?',
        'confirm-first-complete':
          'Uppladdningen är klar! Dela projektet så att dina filer kan hämtas.',
        deliverable_not_found_error: 'Hm, den leveransen verkar ha raderats',
        general_error: 'Oj! Något gick snett. Försök igen.',
      },
      'onboarding-promise': {
        description:
          'Beskriv allt arbete som du ska leverera för ett projekt och effektivisera ditt sätt att dela det. Skapa en lista över alla leveranser och lägg sedan till filer efter hand – du behöver inte längre använda olika hämtningslänkar.',
        title: 'Börja på rätt spår för att fortsätta på rätt spår',
      },
      onboarding: {
        banner:
          'Hallå där! Du är en av några få utvalda som har tillgång till Projekt medan funktionen fortfarande byggs (och förbättras). Det kan hända att vi hör av oss till dig för att få feedback.',
      },
      pagename: 'Projekt',
      placeholders: {
        description: 'Ge ditt projekt en kort beskrivning',
        loading: 'Läser in …',
      },
      project: {
        notification: {
          name_saved: 'Namnet har sparats! Ditt projekt låter som en vinnare.',
        },
      },
      share_button_label: 'Dela',
      unnamed_project_title: 'Namnlöst projekt',
      watch_video: 'Se videon',
    },
    transfer: {
      display_name_fallback: 'Namnlös överföring',
      does_not_expire: 'tillgänglig <u>tills vidare</u>',
      expires_in: 'Tillgänglig i <span>%{time}</span> till',
      downloaded_at: 'Hämtad %{date}, kl. %{time}',
      not_downloaded: 'Inte hämtad än',
      email_bounced: 'Hmm, mottagarens e-postadress verkar inte finnas',
      count_files: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      sent_datetime: 'Skickad %{date}, kl. %{time}',
      never_expires: 'Tillgänglig tills vidare',
      and_more: 'Och %{count} till',
      read_more: 'till',
      copy_link: 'kopiera länk',
      message: 'Meddelande',
      total_downloads: 'Totalt antal hämtningar',
      sent_to_recipients: {
        one: 'Skickat till %{count} person',
        other: 'Skickat till %{count} personer',
      },
      no_transfers: 'Alla överföringar du skickar kommer att visa här',
      add_first_description:
        'Kontrollera hämtningsstatus eller redigera, vidarebefordra eller radera dem',
      mobile: {
        download: 'Hämta samtliga filer',
        remove: 'Ta bort överföring',
      },
      delete_datetime: 'Raderades %{date} klockan %{time}',
      detail: {
        plus_download_stats:
          'Skaffa Pro för att hålla koll på hur många gånger dina överföringar hämtas.',
        plus_password_expiration:
          'Skaffa Pro för att lösenordsskydda dina överföringar och välja hur länge de ska vara tillgängliga.',
        plus_transfer_actions:
          'Skaffa Pro för att när som helst hantera eller ta bort dina överföringar.',
        title: 'Information om dina överföringar',
      },
      download_status_email: '%{count} av %{total} människor',
      download_status_email_text: {
        zero: 'Inte hämtad än',
        one: '%{count} av %{total} människor',
        other: '%{count} av %{total} människor',
      },
      download_status_link: {
        one: 'en gång',
        other: '%{count} gånger',
      },
      download_status_link_text: {
        zero: 'Inte hämtad än',
        one: 'En gång',
        other: '%{count} gånger',
      },
      sent_moment: 'Skickades %{moment}',
      total_downloads_tooltip:
        'Stämmer det inte med vad du väntade dig? Vi har nyligen gjort en liten ändring. Den här siffran visar bara slutförda hämtningar.',
      display_name: {
        label: 'Titel',
        label_mobile:
          'Lägg till en titel så att folk vet vad din överföring innehåller',
      },
      download_status_received_text: {
        zero: 'Inte hämtad än',
        one: 'Hämtad',
        other: 'Hämtade',
      },
      edit_display_name: {
        cancel: 'Avbryt',
        save: 'Spara',
        title: 'Titel',
      },
      received_datetime: 'Mottagna %{date}, kl. %{time}',
      received_from: 'Mottagna från',
      received_moment: 'Mottagna %{moment}',
      teams: {
        received_by: 'Mottagen av',
        self: 'mig',
        sent_by: 'Skickad av',
      },
      title: 'Titel',
      set_password: {
        added: 'Tillagt',
        change: 'Ändra',
        remove: 'Ta bort',
        description:
          'Ange ett lösenord för att kontrollera vem som har tillgång till överföringen.',
        remove_warning:
          'Vill du ta bort lösenordsskyddet från den här överföringen?',
        yes_remove: 'Ja, ta bort',
      },
      set_expiration: {
        description:
          'Ange ett utgångsdatum för att begränsa åtkomsten till den här överföringen.',
        label: 'Tillgänglig till',
      },
      anon_upsell_no_account:
        'Om du vill redigera eller spåra hämtningar för den här överföringen innan den går ut kan du <a href="%{href}">registrera dig</a> gratis.',
      anon_upsell_found_account:
        'Om du vill redigera eller spåra hämtningar för den här överföringen innan den går ut kan du <a href="%{href}">logga in</a>.',
      anon_upsell_no_account_with_button:
        'Du kan ändra denna överföring innan den löper ut genom att skapa ett konto.',
      create_free_account: 'Skapa ett gratiskonto',
    },
    transfers: {
      space_used_unlimited: ' %{space} av lagringsplatsen utnyttjad',
      pagename: 'Överföringar',
      search: 'sök på filnamn',
      search_results: {
        one: '%{count} sökresultat',
        other: '%{count} sökresultat',
        none: 'Inga resultat',
        retry:
          'Det verkar inte som att vi kan hitta en överföring som matchar din sökning. Testa igen.',
      },
      space_used: '%{space} av %{totalSpace} används',
      selected_text: {
        one: '%{count} överföring vald, %{size} totalt',
        other: '%{count} överföringar valda, %{size} totalt',
      },
      last_7_days: 'Skickat de senaste 7 dagarna',
      over_7_days: 'Skickat för mer än 7 dagar sedan',
      sort_on: 'Sortera efter:',
      size: 'Storlek',
      name: 'Namn',
      date: 'Datum',
      delete: 'Radera',
      download: 'Hämta',
      forward: 'Vidarebefordra',
      remove: 'Radera',
      select: 'Välj',
      copy_link: 'Kopiera länk',
      sent_time_ago: 'Skickat för %{timeAgo} sedan',
      files: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      confirm_transfer_delete:
        'Vänta! Är du säker på att du vill radera den här överföringen?',
      confirm_forward:
        'Genom att vidarebefordra denna ersätts pågående överföring. Vill du fortsätta?',
      confirm_expired_transfer_delete:
        'Det här kommer att radera filerna och överföringen för alltid. Vill du fortsätta?',
      deleting_now: 'Vi tar bort detta åt dig nu',
      deselect_all_transfers: {
        one: 'Avmarkera alla överföringar',
        other: 'Avmarkera alla %{count} överföringar',
      },
      downloads: 'Hämtningar',
      expiration: 'Giltighetsdatum',
      expiration_next: 'Giltig i %{days}',
      expiration_no_date: 'Inget giltighetsdatum',
      expiration_not_soon: 'Är giltig ett tag till',
      include_archived_switch_label:
        'Inkludera information om raderade överföringar',
      include_archived_switch_tooltip:
        'Dessa tar inte upp ditt lagringsutrymme',
      notify_completed:
        'Filöverföringen är klar. Du kan stänga den här panelen. Eller fortsätta att titta på den, det är också okej.',
      preview: 'Förhandsgranska',
      remove_permanently: 'Radera informationen för alltid',
      search_placeholder: 'Sök efter filnamn eller mejladress',
      select_all_transfers: {
        one: 'Välj alla överföringar',
        other: 'Välj alla %{count} överföringar',
      },
      space_left: '%{space} av %{totalSpace} kvar',
      teams_tip: {
        subtitle:
          'Den här sidan visar din egen överföringsaktivitet. Ifall du undrade så kan dina teammedlemmar bara se sina egna överföringar också.',
        title: 'Ditt Pro-team växer …',
      },
      title: 'Skickade överföringar',
      view_details: 'Visa detaljer',
      edit_display_name: 'Redigera titel',
      received_time_ago: 'Mottagna för %{timeAgo} sedan',
      search_title_placeholder: 'Sök efter titel, filnamn eller mejladress',
      see_all: 'Visa alla (%{count})',
      sender: 'Avsändare',
      sort_by_title: 'Titel',
    },
    accountinfo: {
      pagename: 'Kontoinformation',
      signed_in_as: 'Inloggad som %{name}',
      sign_out: 'Logga ut',
      paid_on: 'Betalat den',
      no_invoices:
        'Dina kvitton visas här men det ser ut som om du inte har några än. Tur för dig!',
      subscription_info:
        'Din Pro-prenumeration på %{deal} förlängs automatiskt den %{autorenewal_attempt}.',
      payment_success: {
        monthly: 'Bra! Nu är allt klart för en hel månad med WeTransfer Pro.',
        monthly_renewal: 'Bra! Nu är allt klart för en till månad med Pro.',
        yearly: 'Bra! Nu är allt klart inför ett helt år med WeTransfer Pro.',
        yearly_renewal: 'Bra! Nu är allt klart för ett år till med Pro.',
      },
    },
    changepassword: {
      pagename: 'Ändra lösenord',
    },
    invoices: {
      pagename: 'Kvitton',
    },
    reviewbilling: {
      pagename: 'Bekräfta din betalningsinformation',
      information:
        'För att kunna ändra din betalningsmetod måste vi samtidigt förlänga din prenumeration',
      information_payment:
        'Du kommer att debiteras %{deal} för nästa %{period} med Pro – din prenumeration gäller till och med %{expiry}',
    },
    renewbilling: {
      pagename: 'Granska dina uppgifter och förläng',
    },
    link_downloads_unsubscribe: {
      body: 'Du kan sluta prenumerera på meddelanden om att filer som delas med en överföringslänk har hämtats. Du kan fortfarande hålla koll på dina hämtningar i panelen Skickade.',
      cta: 'Gå till mina skickade överföringar',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Välj från galleriet',
        },
        next_button: 'Färdigt',
        description:
          'Välj en bakgrundsbild och bestäm hur din profil- och hämtningssida ska se ut. Läckert, eller hur? Du kan ladda upp din egen eller välja bland några av våra alternativ.',
      },
      upload_wallpaper: {
        add_text: 'Ladda upp en bild',
        add_description:
          'Ladda upp en bild på 2 560 x 1 600 pixlar för bästa möjliga resultat. Maximal filstorlek är 3 MB.',
        upload_text: 'Ladda upp en bild eller video',
      },
      preview: {
        wallpaper_credits_prefix: 'Bakgrundsbild av',
      },
      1: {
        description:
          '&quot;Anpassa vad andra ser varje gång du skickar filer till dem. Och med din egen WeTransfer-sida kan vem som helst skicka dig %{transfer_limit} överföringar – du behöver bara ge dem din URL. Din e-postadress visas på sidan så att de kan vara säkra på att filerna kommer att skickas till dig.<br /><br />\nDet första steget är att välja din URL.&quot;',
        next: 'Nästa',
        skip: 'Hoppa över',
        warning:
          '<strong>Varning!</strong> Du kan bara välja det här en gång (ingen press!)',
        'blurb-1':
          'Skapa en egen WeTransfer-sida för en proffsig look varje gång någon hämtar dina filer, och gör det (ännu) enklare för vem som helst att skicka överföringar till dig.',
        'blurb-2': 'Börja med att välja din URL.',
        welcome: 'Gör ett gott intryck med en egen WeTransfer-sida',
        information:
          'Oroa dig inte, du kan när som helst ändra detta i <strong>Varumärkning</strong>.',
        description_unlimited:
          'Anpassa vad man ser när du skickar filer till folk. Och med din egen WeTransfer-sida kan vem som helst skicka filer i alla storlekar – bara ge dem din URL. Din mejladress kommer att visas på sidan så att man kan lita på att filerna kommer att skickas till dig. <br /><br /> \nVälj först din URL.',
      },
      2: {
        description:
          'Du kan välja upp till fem bakgrundsbilder (eller wallpapers som vi kallar dem) till din profil.\n\nSätt dig eller ditt varumärke i centrum och skicka snyggt paketerade filer',
        pick: 'Välj från vårt galleri',
        title: 'Gör ett starkt intryck med varje överföring',
        upload: 'Ladda upp din egen',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> är konfigurerad. Nu kan du lägga till den här länken till din webbplats så att andra kan skicka överföringar på %{transfer_limit} till dig – eller så kan du själv skicka någonting.',
        done: 'Klar',
        title: 'Vilken snygg profil',
        description_unlimited:
          '<strong>%{customLink}</strong> är konfigurerad. Nu kan du lägga till den här länken till din webbplats så att man kan skicka överföringar till dig oavsett storlek – eller så kan du skicka någonting.',
      },
    },
    contact: {
      add_contact: 'Lägg till kontakt',
      add_first_description:
        'Här sparar vi också e-postdresserna du skickar filer till',
      add_to_transfer: 'Lägg till i överföringen',
      remove_from_transfer: 'Ta bort från överföringen',
      confirm_delete: {
        one: 'Är du säker på att du vill radera den här kontakten?',
        other: 'Är du säker på att du vill radera %{count} kontakter?',
      },
      contact_count: {
        one: '%{count} kontakt',
        other: '%{count} kontakter',
      },
      edit: 'Redigera',
      mobile: {
        add: 'Lägg till kontakt',
      },
      no_contacts: 'Lägg till din första kontakt!',
      pagename: 'Kontakter',
      remove: 'Radera',
      search_count: {
        one: '%{count} sökresultat',
        other: '%{count} sökresultat',
      },
      search_placeholder: 'sök på e-postadress, namn eller företag',
      select: 'Välj',
      selected_text: {
        one: '%{count} kontakt vald',
        other: '%{count} kontakter valda',
      },
      teams_tip: {
        subtitle:
          'När du skickar en överföring till någon lägger vi till dem bland dina kontakter. Alla i ditt team kan skapa en egen lista.',
        title: 'Ditt Pro-team växer …',
      },
    },
    unsubscribeexpiration: {
      button: 'Avregistrera dig',
      button_unsubscribed: 'Tillbaka till WeTransfer',
      description:
        'Får du för många mejl? Inga problem! Vi kan sluta med att skicka påminnelser om överföringar som snart blir otillgängliga.',
      description_unsubscribed:
        'Du kommer inte längre att få några mejl om överföringar som snart blir otillgängliga',
      no_email: 'dig',
      title: 'Säg upp din e-postprenumeration på meddelanden med påminnelser',
      title_unsubscribed: 'Klart!',
      downloaded: {
        body: 'Vi fattar. Du kan avbeställa påminnelser om att dina överföringar snart blir otillgängliga när dina filer redan har hämtats. Detta kommer inte att förändra om vi skickar mejl med påminnelser om att personer inte har hämtat dina filer än',
        cta: 'Avbeställ',
        title:
          '"Mina filer har hämtats. Jag behöver inte mejl om att överföringar snart blir otillgängliga."',
      },
      not_downloaded: {
        body: 'Inga problem. Du kan avbeställa påminnelser om att överföringar snart blir otillgängliga även om ingen har hämtat dina filer än.',
        cta: 'Avbeställ',
        title:
          'Behöver du inte mejl om överföringar som snart blir otillgängliga?',
      },
      pro: {
        body_1:
          'Det är helt lugnt. Du kan avbeställa sådana påminnelser. I avsnittet med detaljer om dina överföringar kan du fortfarande hålla koll på när överföringarna ska bli otillgängliga och när som helst ändra hur länge de ska kunna hämtas.',
        body_2:
          'Psst, du kan skriva en rad på <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> om du ångrar dig eller fastnar någonstans. Det är inga konstigheter.',
        cta: 'Avbeställ',
        title:
          'Behöver du inte mejl om att överföringar snart blir otillgängliga?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Är du säker på att du vill rensa dina cookies?',
        },
      },
    },
    about_plus: {
      checklist: {
        title: 'Uppgradera till Pro idag för %{currency}%{price}/månad',
      },
    },
    advertise: {
      gallery: {
        preview: 'Förhandsgranska',
      },
      guidelines: {
        advert_static: {
          title: 'Statisk bakgrundsbild',
        },
      },
    },
    billinginfo: {
      pagename: 'Faktureringsinformation',
    },
    help: {
      button_all_answers: 'Fler svar',
      page_title: 'Snabbhjälp',
      read_more: 'Läs mer',
      search_button: 'Sök',
      search_placeholder: 'Vad kan vi hjälpa till med?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Läser in …',
    },
    payment_update: {
      bancontact: {
        info: 'Bara så att du är med på noterna – för att kontrollera att dina uppgifter är korrekta kommer Bancontact att debitera en engångsavgift på 0,01 EUR',
      },
      confirm_update: 'Bekräfta',
      ideal: {
        info: 'Bara så att du är med på noterna – för att kontrollera att dina uppgifter är korrekta kommer iDEAL att debitera en engångsavgift på 0,01 EUR',
      },
      info: 'Bara så att du är med på noterna – för att kontrollera att dina uppgifter är korrekta kommer iDEAL att debitera en engångsavgift på 0,01 EUR',
      sofort: {
        info: 'Bara så att du är med på noterna – för att kontrollera att dina uppgifter är korrekta kommer SOFORT att debitera en engångsavgift på 0,01 EUR',
      },
      title: 'Uppdatera betalningsuppgifter',
      update_in_progress: 'Uppdaterar dina uppgifter …',
    },
    sign_in: {
      account: 'Har du inget konto?',
      upgrade: 'Uppgradera till WeTransfer Pro',
    },
    signin: {
      account_cta: 'Skapa ett konto',
      account_item_1: 'Skicka upp till %{size_limit}',
      account_item_2: 'Hantera överföringar',
      account_item_3: 'Lagra upp till %{storage_limit}',
      account_subtitle: 'Gratis',
      plus_cta: 'Skaffa WeTransfer Pro',
      plus_item_1: 'Skicka upp till %{size_limit}',
      plus_item_2: 'Hantera överföringar',
      plus_item_3: 'Lagra upp till %{storage_limit}',
      plus_item_4: 'Dina egna bakgrunder',
      plus_item_5: 'En personlig URL',
      plus_item_6: 'Lösenordsskydda överföringar',
      plus_month: '/månad',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Avböj inbjudan',
      },
      invitees: {
        title: 'Inbjuden – väntar på svar',
      },
      member: {
        action_demote: 'Ta bort som administratör',
        action_promote: 'Gör till administratör',
        action_revoke: 'Ta bort från teamet',
      },
      members: {
        title: 'I ditt team',
      },
      no_access: {
        description:
          'Håll ögon och öron öppna. Vi hör av oss när den är klar. ',
        title:
          'Attans, den här funktionen verkar fortfarande vara topphemlig. ',
      },
      subtitle: {
        members: {
          one: '%{count} medlem',
          other: '%{count} medlemmar',
        },
        pending: '%{pendingCount} inbjuden',
      },
      tip: {
        button: 'Läs mer',
        subtitle:
          'Med vår splitternya Pro för team-funktion har vi gjort den bästa WeTransfer-upplevelsen ännu bättre! Lägg till nya medlemmar utan kostnad. Använd det superenkla formuläret nedan för att komma igång. Det är bara att tuta och köra så snart de accepterar din inbjudan!',
        title: 'Ett team är större än en person …',
      },
      title: 'Teammedlemmar',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Tillgänglig i %{expiry} till',
      },
      recipients: 'Skickar till',
      upsell: {
        benefit_one: 'Se när dina filer hämtades',
        benefit_three: 'Granska och skicka dina gamla överföringar igen',
        benefit_two: 'Se vem som hämtade dina filer',
        button: {
          action: 'Berätta mer',
          cancel: 'Nej tack',
        },
        heading: 'Hantera enkelt dina överföringar med WeTransfer Pro',
        title: 'Din överföringsinformation',
      },
    },
    transferReceived: {
      'empty-description':
        'Här hittar du alla överföringar som skickats till dig. Och oroa dig inte, de kommer inte att ta upp något lagringsutrymme.',
      'empty-title': 'Håll koll på överföringar',
    },
    unsubscribeonboarding: {
      action: 'Avsluta prenumeration',
      back: 'Tillbaka till WeTransfer',
      contact:
        'Psst, om du fastnar någonstans kan du hojta till på <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> – vi tar inte illa upp.',
      done: 'Allt klart!',
      message:
        'Du kan sluta prenumerera på våra introduktionsmejl. Oroa dig inte. Du kommer fortfarande att få allt som är viktigt.',
      title: 'Börjar det bli trångt i inkorgen?',
    },
    userinfo: {
      pagename: 'Personuppgifter',
    },
    free_onboarding: {
      close: 'Stäng',
      finish_tour: 'Klart',
      next: 'Nästa',
      send_files: 'Nu är det bara att sätta igång att skicka filer',
      start_tour: 'Se vad mer vi har att bjuda på',
      step_one: {
        body_1:
          'Nu när du har verifierat mejladressen för ditt konto behöver du inte göra det varje gång du skickar en överföring. Inga fler verifieringskoder!',
        body_2:
          'Håll koll på alla skickade och mottagna överföringar på en och samma plats. Se hur många gånger dina filer har hämtats. Skicka en gång till, vidarebefordra eller ta bort dina överföringar med ett klick.',
        header_1: 'Verifierad en gång för alla',
        header_2: 'Hantera dina överföringar',
        subtitle:
          'Säg hej då till verifieringskoder och borttappade hämtningslänkar. Ditt nya konto ger dig det enklaste sättet att skicka stora filer – gratis.',
        title_1: 'Skicka filer <strong>på dina villkor</strong>',
        title_2: 'med WeTransfer',
      },
      step_three: {
        body_1:
          'Oavsett om det är en video på telefonen eller en länk på datorn så kan du spara din inspiration på ett ställe. Öppna Collect med startprogrammet (det är den där grejen längst upp till vänster) eller använd länken nedan för att komma igång.',
        cta: 'Öppna Collect',
        title_1: '<strong>Spara inspiration</strong> på stående fot',
        title_2: 'med Collect',
      },
      step_two: {
        body_1:
          'Pitcha idéer. Visa halvfärdiga projekt. Håll dig uppdaterad. Utan att formatera en presentation igen, någonsin. Öppna Paste med startprogrammet (det är den där grejen längst upp till vänster) eller använd länken nedan för att komma igång.',
        cta: 'Öppna Paste',
        title_1: 'Skapa <strong>presentationer på ett ögonblick</strong>',
        title_2: 'med Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Testa portals',
        pill: 'En splitterny funktion',
        text: 'Vi introducerar <strong>portals</strong>, ett enklare sätt att få godkännandet du behöver. Bjud in kunder och medarbetare så att de kan se filer och välja ut sina favoriter – inga filer behöver hämtas.',
        title: 'Dela ditt arbete. Få feedback. Allt på samma plats.',
      },
    },
    not_found: {
      body: 'Gå tillbaka till <a href="https://wetransfer.com/">wetransfer.com</a> eller muntra upp dig med några <a href="https://wepresent.wetransfer.com/">trevliga saker som vi har skrivit</a>.',
      image_alt: 'Något gick fel',
      title: 'Oj! Det gick inte att hitta den sidan.',
    },
    password_and_security: {
      title: 'Lösenord och säkerhet',
      'two-factor-authentication': {
        description: {
          enabled: 'Sedan %{date}',
        },
        disable: 'Stäng av',
        done: 'Klart',
        enable: 'Aktivera',
        get_recovery_codes: 'Hämta återställningskoder',
        next_step: 'Nästa',
        recovery_code_action: 'Generera nya koder',
        recovery_code_keep_safe:
          'Varje kod kan bara användas en gång men du kan alltid få fler om du skulle behöva det.',
        recovery_code_need_more:
          'Behöver du återställningskoder? Du kan alltid generera nya. Tänk bara på att det gör alla aktuella koder ogiltiga.',
        recovery_code_title: 'Dina återställningskoder',
        require_password_action: 'Ange',
        require_password_text: 'Ange ditt lösenord för att fortsätta',
        step_one_action: {
          app_store: 'Hämta i App Store',
          google_play: 'Hämta den i Google Play',
        },
        step_one_label: 'Steg 1 (av 3)',
        step_one_text:
          'Du kommer att behöva en autentiseringsapp på din telefon. Om du redan har Google Authenticator (eller en annan app) klickar du på nästa.',
        step_one_title: 'Hämta Google Authenticator',
        step_three_label: 'Steg 3 (klart!)',
        step_three_text:
          'Om du behöver logga in på ditt konto utan att ha telefonen med dig (vi har hört att sånt händer) kan du använda en av de här återställningskoderna. Vi sparar inte koderna åt dig och kommer inte att visa dem för dig igen så spara dem nu – och se till att hålla dem lika säkra som koden till ditt bankkonto.',
        step_three_text_2:
          'Håll de här koderna lika säkra som lösenordet till bankkontot! Varje kod kan bara användas en gång.',
        step_three_title: 'Spara återställningskoder',
        step_two_form: {
          error: 'Aj då, den koden är fel eller är inte giltig längre',
          label: 'Verifieringskod',
        },
        step_two_label: 'Steg 2 (nu är du halvvägs)',
        step_two_text:
          'Använd din autentiseringsapp för att skanna in streckkoden. Appen kommer att generera en sexsiffrig verifieringskod. Ange den nedan.',
        step_two_text_mobile:
          'Ange den här koden i din autentiseringsapp. Appen kommer att generera en sexsiffrig verifieringskod. Ange den koden nedan.',
        step_two_title: 'Skanna streckkod',
        step_two_title_mobile: 'Ange kod',
        text: {
          protect_account:
            'Använd telefonen för att ge ditt konto ett extra säkerhetsskikt.',
        },
        title: 'Tvåfaktorautentisering',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Få det bästa från Paste® och Collect',
      },
      cta: 'Nej, jag vill ha kvar Pro',
      'cta-2': 'Avsluta min prenumeration',
      disclaimer: {
        collect: 'Ditt lagringsutrymme går från 200 GB till 5 GB i Collect',
        paste:
          'Går du från att ha ett obegränsat antal tavlor till tre tavlor i Paste®',
        'team-member':
          'Du kommer att tas bort från %{currentTeam} på WeTransfer Pro.',
        teams:
          'Ditt team på %{amountOfMembers} personer kommer att tas bort från %{currentTeam} på WeTransfer Pro',
        title:
          'När din aktuella prenumeration löper ut den <strong>%{date}</strong>:',
        'transfer-expiry':
          'Kommer dina överföringar att tas bort efter 28 dagar',
        'transfer-team-member':
          'Du kommer inte att kunna ta emot och skicka överföringar som en del av teamet, och inte heller hantera teamets befintliga överföringar.',
      },
      'password-expiry': {
        title:
          'Lösenordsskydda överföringar och bestäm hur länge de ska vara tillgängliga',
      },
      personalization: {
        title: 'Personanpassa din egen WeTransfer-sida',
      },
      portals: {
        text: 'Med %{planName} kan du använda <a href="%{href}" target="_blank">portaler</a> för att dela ditt arbete med kunder som ska granska det – ingen hämtning krävs.',
        title: 'Dela ditt arbete och få feedback från en och samma plats',
      },
      'stay-pro': 'Behåll prenumerationen',
      'storage-limit': {
        title: 'Få %{storage_limit_pro} lagringsutrymme per person',
      },
      subtitle:
        'Om du avslutar nu går du miste om följande från och med %{date}:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Bjud in teammedlemmar</a> att skicka, ta emot och hantera överföringar tillsammans – eller jobba ensam utan kostnad.',
        'team-member-text':
          'Du kommer att tas bort ur ditt team och ni kommer inte längre att kunna skicka, ta emot eller hantera överföringar tillsammans.',
        'team-owner-text':
          'Du har <a href="%{href}" target="_blank">%{amountOfMembers} teammedlemmar</a> som inte längre kommer att kunna skicka, ta emot eller hantera överföringar tillsammans.',
        title: 'Arbeta på stora idéer som ett team',
      },
      title: 'Är du säker på att du är redo att ge upp %{planName}?',
      'transfer-limit': {
        text: 'Just nu kan du skicka och ta emot större överföringar – mycket större än de %{transfer_limit_free} du får gratis.',
        title: 'Skicka 100 gånger större överföringar',
      },
      'transfer-unlimited': {
        text: 'Du kan skicka (och ta emot) överföringar utan storleksbegränsningar – ofantligt mycket mer än de %{transfer_limit_free} som du får gratis.',
        title: 'Skicka överföringar av alla storlekar',
      },
    },
    pricing: {
      pro: {
        per_person: 'per person',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Skapa konto',
        current_plan: 'Nuvarande paket',
        sign_up: 'Registrera dig',
        switch_premium: 'Ändra till Premium',
        switch_pro: 'Byt till Pro',
        upgrade: 'Uppgradera',
      },
      faq: {
        answers: {
          answer_1:
            'Du kommer att kunna komma igång med WeTransfer Pro eller WeTransfer Premium så snart du har slutfört din betalning. Vi skickar också ett bekräftelsemejl med din betalda faktura bifogad. <br /><br /> \n \nNär du väl är igång kommer du att kunna skicka större överföringar, börja använda portaler och skapa en alldeles egen WeTransfer-sida direkt. Om du har några tidigare överföringar som skickades medan du hade gratispaketet kommer du också att kunna ändra utgångsdatumen till valfritt datum.',
          answer_2:
            'När du använder WeTransfer kan vem som helst ladda ner dina filer – de behöver inte logga in eller registrera sig. De måste acceptera våra användarvillkor och vi kan be dem att acceptera kakor, men det är allt!<br /><br /> \n \nOm du vill dela arbete eller samarbeta i portaler (WeTransfers senaste funktion), behöver dina kunder och medarbetare inte registrera sig för att se och välja filer, lägga till kommentarer, ge godkännande eller ladda ner filer. Du behöver bara lägga till teammedlemmar till ditt Pro- eller Premium-paket om du vill att folk ska kunna lägga till omdömen och skapa portaler med dig.',
          answer_3:
            'Med ett Pro- eller Premium-paket kan du skapa din egen WeTransfer-sida där vem som helst kan skicka filer till dig med överföringsstorleksgränsen för ditt paket. Det betyder att du kan få de stora filerna du behöver från kunder eller samarbetspartners, och de behöver inte ha ett konto – bara webbadressen till din sida. (Även om vi kan be dem att verifiera sin e-postadress för att skydda dig från "utländska prinsar" som "vill skicka pengar till dig").',
          answer_4:
            'Först måste du registrera dig för WeTransfer Pro eller WeTransfer Premium – du kan inte lägga till teammedlemmar med gratispaketet. Och vilket paket du än väljer kommer dina teammedlemmar att få samma förmåner (så du kan till exempel inte skaffa Premium till dig själv och låta några teammedlemmar få Pro). Teammedlemmar kommer att kunna skicka och ta emot större överföringar från din WeTransfer-sida och hantera överföringar från en delad översikt. <br /><br />\n \nNär du har registrerat dig för det paket som är bäst för ditt team kan du bjuda in så många teammedlemmar du vill från dina teamhanteringsinställningar. Du kan lägga till och ta bort medlemmar från ditt team när som helst medan din prenumeration är aktiv.',
          answer_5:
            'Vi accepterar PayPal samt kreditkort från stora nätverk som Visa, Mastercard och American Express. Vi stöder även andra onlinebetalningssystem i vissa länder. <br /><br />\n \nVi accepterar inte direkta banköverföringar eftersom du måste registrera dig för en återkommande års- eller månadsprenumeration. (Vi skickar ett mejl till dig innan detta inträffar för första gången för att förvarna dig).',
          answer_6:
            'Om du inte har det obegränsade lagringsutrymmet med WeTransfer Premium, måste du antingen rensa upp lite lagringsutrymme genom att ta bort några av dina skickade överföringar eller uppgradera ditt paket. Innan du gör det kommer du inte att kunna skicka nya överföringar. <br /><br />\n \nOm du använder WeTransfer gratisversion raderas alla dina överföringar på upp till 2 GB automatiskt efter 7 dagar. Så oroa dig inte, det är inte möjligt för dig att överskrida din lagringsgräns.',
          answer_6_variant_asterisk:
            'Du måste frigöra lite lagringsutrymme genom att ta bort några av dina skickade överföringar eller uppgradera ditt paket. Innan du gör det kan du inte skicka några nya överföringar. <br /><br />\n\nOm du har en Premium-prenumeration och når 5 TB kan du kontakta vårt supportteam och begära mer lagringsutrymme, upp till en maximal årlig gräns på 15 TB. <br /><br />\n\nOm du använder WeTransfer gratis raderas alla skickade överföringar på upp till 2 GB automatiskt efter 7 dagar. Så var inte orolig – du kan inte överskrida din lagringsgräns.',
          answer_6_variant_limited_storage:
            'Du måste frigöra lite lagringsutrymme genom att ta bort några av dina skickade överföringar eller uppgradera ditt paket (om du inte har en Premium-prenumeration). Innan du gör det kan du inte skicka några nya överföringar. <br /><br />\n\nOm du använder WeTransfer gratis raderas alla skickade överföringar på upp till 2 GB automatiskt efter 7 dagar. Så var inte orolig – du kan inte överskrida din lagringsgräns.',
          answer_7:
            'Din prenumeration förnyas automatiskt (vi skickar ett mejl till dig innan detta händer för första gången), men du kan avbryta när som helst. <br /><br />\n \nFör att byta till att använda WeTransfer gratis behöver du bara gå till dina <strong>konto</strong>inställningar och avsluta din prenumeration. Du (och alla teammedlemmar) kommer att kunna fortsätta använda ditt Pro- eller Premium-paket tills din nuvarande prenumerationsperiod tar slut.',
          answer_8:
            'Miljontals människor runt om i världen förlitar sig på WeTransfer och våra verktyg när de ska dela sina idéer. Varje månad skickas över två miljarder filer genom vår plattform.<br /><br />\n\nFör att skydda dina idéer mot attacker eller exploatering krypteras dina filer när de överförs (TLS) och när de lagras (AES-256). När dina filer väl har lagrats kan de endast nås med de unika länkar som skickas till avsändaren och mottagaren.',
        },
        questions: {
          question_1: 'Vad händer efter att jag registrerat mig och betalar?',
          question_2: 'Behöver mina mottagare registrera sig?',
          question_3:
            'Kan jag ta emot större överföringar från vem som helst? ',
          question_4: 'Hur lägger jag till (och tar bort) gruppmedlemmar?',
          question_5: 'Vilka betalningsmetoder kan jag använda?',
          question_6: 'Vad händer om jag överskrider min lagringsgräns?',
          question_7: 'Hur avbryter jag?',
          question_8: 'Kan jag lita på WeTransfer? Hur säkert är det?',
        },
        title: 'Vanliga frågor och svar',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Reklam (och konst)',
            custom: 'Ladda upp din egen',
            feature_1: 'Anpassa We Transfer-sidan',
            feature_2: 'Wallpaper bakgrundsbilder',
            feature_3: 'Anpassade We Transfer-mejl',
          },
          title: 'Visa upp ditt varumärke',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} lagring',
            title: 'Collect från WeTransfer',
          },
          paste: {
            limited_decks:
              'Upp till %{pasteDecksLimit} presentationer med Paste standardlogga',
            title: 'Paste® från WeTransfer',
            unlimited_decks:
              'Obegränsade presentationer med ditt eget varumärke',
          },
          title: 'Komplettera ditt kreativa verktygsset',
        },
        expiry: 'Överföringen är giltig i %{days} days',
        extra_storage: '%{storageLimit} extra per person',
        monthly_price: '%{price} per månad per person',
        portals: {
          features: {
            feature_1: 'Portaler',
            feature_2: 'Granskningar',
            feature_3: 'Kundens varumärke',
          },
          title: 'Dela arbete för feedback och godkännande',
        },
        security: {
          features: {
            feature_1: 'Anpassade utgångsdatum',
            feature_2: 'Lösenordsskyddade överföringar',
            feature_3: 'Datakryptering',
            feature_4: 'Tvåfaktorsautentisering',
          },
          title: 'Säkra dina överföringar',
        },
        storage_limit: '%{storageLimit} per person',
        teams: {
          features: {
            feature_1: 'Bjud in teammedlemmar',
            feature_2: 'Delad överföringsöversikt',
            feature_3: 'Delad lagring',
            feature_4: 'Delat varumärke',
          },
          title: 'Leverera ditt arbete som ett team',
          subtext: {
            text: 'Stöds endast om du köper en prenumeration från vår webbplats.',
            learn_more: 'Läs mer',
          },
        },
        tooltips: {
          tooltip_1:
            'Alla överföringar du skickar räknas med i ditt lagringsutrymme',
          tooltip_10:
            'Du kan skicka och lagra filer säkert med TLS- och AES-256-kryptering',
          tooltip_11: 'Spåra hämtningar och hantera överföringar tillsammans',
          tooltip_12:
            'Visa upp ditt (team)arbete med bakgrunder och e-post med ditt varumärke',
          tooltip_13:
            'Paste är ett presentationsverktyg som designar presentationer åt dig med responsiva färger, justering och layout',
          tooltip_14:
            'Med Collect kan du spara och organisera bilder, videor, musik och länkar på olika enheter',
          tooltip_2:
            'Man kan hämta dina filer utan att behöva logga in eller registrera sig',
          tooltip_3:
            'Håll reda på vem som har (eller inte har) hämtat dina filer',
          tooltip_4: 'Organisera ditt arbete för varje kund och varje projekt',
          tooltip_5:
            'Bjud in kunder att visa och välja filer, lägga till kommentarer och ge godkännande – utan att behöva ladda ner någonting',
          tooltip_6:
            'Lägg till en logga och titel för att anpassa dina portals för varje kund',
          tooltip_7:
            'Din WeTransfer-sida är där man hämtar dina filer och kan skicka dig överföringar inom storleksgränsen för ditt paket',
          tooltip_8:
            'Wallpapers är de videor och bilder du ser i bakgrunden när du skickar och tar emot filer på wetransfer.com',
          tooltip_9:
            'Wow, vi trodde faktiskt inte att någon skulle läsa dessa – du bevisade att vi hade fel. Grattis! Skärmdumpar kanske eller kanske inte retweetas av @WeTransfer',
        },
        transfer_classic: {
          features: {
            feature_1: 'Storleksgräns på överföringar',
            feature_2: 'Lagring',
            feature_3: 'Hämtningar utan konto',
            feature_4: 'Spåra hämtningar',
            feature_5: 'iOS-app',
          },
          title: 'Skicka stora filer',
        },
        unlimited: 'Obegränsad',
        yearly_price: '%{price} per år per person',
      },
      header: {
        subtitle:
          'Oavsett om du skickar stora filer för skojs skull eller levererar arbete åt kunder – fortsätt driva dina kreativa projekt framåt med WeTransfer.',
        title: {
          english_1: 'Du har idéerna,',
          english_2: 'vi har paketen',
          general: 'Paket och priser',
        },
      },
      plans: {
        billing: {
          discount: 'Spara %{percentage} (ooh yeah)',
          monthly: 'Månadsfakturering',
          yearly: 'Årlig fakturering',
        },
        free: {
          subtitle: 'Skicka filer då och då',
          title: 'Gratis',
          usp: {
            feature_1: 'Skicka upp till %{transferLimit}',
            feature_2: 'Överföringar behöver inte verifieras',
          },
        },
        premium: {
          subtitle: 'Dela arbete utan begränsningar',
          title: 'Premium',
          usp: {
            feature_1: 'Ingen storleksbegränsning på överföringarna',
            feature_2: 'Obegränsad lagring',
            feature_2_subtitle:
              '*Den initiala gränsen är %{storageLimit}, med möjlighet att lägga till extra lagringsutrymme på begäran. En maximal årlig gräns på %{annualStorageLimit} gäller. Läs våra <a href="/legal/terms" data-route-type="premium" target="_blank">användarvillkor</a> för mer information.',
            feature_3: 'Obegränsade portals och granskningar',
          },
        },
        pro: {
          subtitle: 'Skicka stora filer regelbundet',
          title: 'Pro',
          usp: {
            feature_1: 'Skicka och ta emot upp till %{transferLimit}',
            feature_2: '%{storageLimit} lagring per person',
            feature_3: '%{portalsLimit} portal, obegränsade granskningar',
          },
        },
        tagline: {
          free: 'inga pengar, inga problem',
          monthly: 'per månad och person',
          yearly: 'per år och person',
          per_person_monthly: 'per person, faktureras månatligen',
          per_person_yearly: 'per person, faktureras årligen',
          tax_included: 'skatt ingår',
        },
        title: 'Välj ditt paket',
        month: 'månad',
      },
      skip_link: 'Hoppa till fler funktioner',
    },
    pro_classic: {
      hero: {
        cta_1: 'Läs mer',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Du har idéerna, vi har paketen',
      },
      cta: 'Jag vill bara skicka filer',
      free_panel: {
        cta: 'Registrera dig',
      },
      plan: {
        free: {
          feature_1: 'Skicka upp till <strong>%{transfer_limit}</strong>',
          feature_2: 'Överföringar behöver inte verifieras',
          subtitle_new: 'För tillfälliga filsändare',
          title: 'Gratis',
        },
        pro: {
          feature_1:
            'Skicka och ta emot upp till <strong>%{transfer_limit}</strong>',
          feature_2: 'Välj hur länge överföringar ska vara tillgängliga',
          feature_5: '1 TB lagring per person',
          subtitle_new: 'För proffs och team',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Registrera dig nu',
          descripttion: 'Håll koll på överföringar',
          feature_1: 'Skicka upp till 2 GB',
          feature_2: 'Ta emot överföringar i en och samma översikt',
          title: 'Gratis',
        },
        pro: {
          cta: 'Läs mer',
          descripttion: 'Utnyttja WeTransfer till max',
          feature_1: 'Skicka och ta emot upp till %{transfer_size}',
          feature_2:
            '%{storage_size} lagringsutrymme för överföringar per person',
          feature_3: 'Skicka överföringar med anpassade inställningar',
          title: 'Pro',
        },
        title: 'Låt inte dina överföringar försvinna i inkorgen.',
      },
      title: 'Utnyttja nya WeTransfer fullt ut',
    },
    teamsettings: {
      invite: {
        cta: 'Bjud in team',
        pagename: 'Bjud in team',
      },
      manage: {
        cta: 'Hantera team',
      },
      members:
        'Du har %{amountOfMembers} teammedlemmar. <a href="%{href}">%{cta}</a>',
      no_members: 'Just nu är det bara du! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Teaminställningar',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Samarbeta och överför tillsammans',
        context:
          'Skicka och ta emot överföringar som ett team, med delat lagringsutrymme, varumärkning och åtkomst till varandras överföringar.',
        invite_team: 'Bjud in team',
        dismiss: 'Kanske senare',
      },
      feature_highlight: {
        free_context:
          'Du kan nu hantera skickade och mottagna överföringar på en enkel översikt. Du får veta vilka filer som hämtas på minuten. Skicka om, vidarebefordra eller hämta dina överföringar med ett klick. Lätt som en plätt',
        free_subtitle: 'Alla dina överföringar på ett ställe',
        paste_collect_link:
          'Gå till <a href="%{pasteUrl}" rel="external">%{pasteName}</a> eller <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Du kan nu skicka överföringar av valfri storlek och skapa din egen <b>WeTransfer-sida</b> för att anpassa vad andra ser när de hämtar dina filer. Är du redo att välja webbadress och bakgrundsbilder?',
        premium_cta: 'Skapa sida',
        premium_dismiss: 'Kanske senare',
        premium_subtitle: 'Konfigurera din WeTransfer-sida',
        premium_team_context:
          'Du kan nu skicka och ta emot överföringar i alla storlekar från ditt teams anpassade WeTransfer-sida.',
        pro_context:
          'Du kan nu skicka upp till %{transfer_limit} på en gång och skapa din egen <b>WeTransfer-sida</b> för att anpassa vad andra ser när de hämtar dina filer. Är du redo att välja webbadress och bakgrundsbilder?',
        pro_team_context:
          'Du kan nu skicka och ta emot %{transfer_limit} överföringar från ditt teams <b>anpassade WeTransfer-sida</b>.',
        send_cta: 'Skicka filer',
        team_subtitle: 'Leverera kreativt arbete som ett team',
      },
      marketing: {
        context:
          'Nu när vi vet lite om dig vill vi gärna berätta lite om oss. Vill du ha berättelser om kreativitet och de senaste WeTransfer-nyheterna?',
        image_alt_text:
          'Exempel på e-postinnehåll, inklusive nya produktfunktioner, branschrapporter och WePresent-artiklar som berättar historier om kreativitet.',
        opt_in: 'Ja tack',
        opt_out: 'Nej tack',
        unsubscribe:
          'Du kan alltid avsluta prenumerationen senare – vi är inte långsinta.',
      },
      welcome: {
        context:
          'Genom att lära känna dig bättre kan vi förbättra vår service.',
        cta: 'Fortsätt',
        dismiss: 'Hoppa över',
        dropdown_options: {
          architecture: 'Arkitektur/konstruktion',
          data: 'Data/finans/juridik',
          design: 'Design/illustration',
          education: 'Utbildning/studier',
          marketing: 'Marknadsföring/PR',
          music: 'Musik/ljud',
          other: 'Annat (och stolt över det)',
          photography: 'Fotografi',
          product: 'Produkt/programvara',
          sales: 'Försäljning/kundrelationer',
          video: 'Video/animering',
        },
        free_tier_title: 'Välkommen till WeTransfer, %{name}!',
        placeholder: 'Hmm, låt oss se ...',
        question: 'Först av allt, inom vilken bransch jobbar du?',
        team_title: 'Du är med i teamet, %{name}!',
        tier_title: 'Välkommen till WeTransfer %{tier}, %{name}!',
        data_opt_in: {
          checkbox_label:
            'Låt WeTransfer använda de uppgifter som du delar för att visa dig skräddarsydda annonser på och utanför våra webbplatser.',
          tooltip_anchor: 'Vad betyder det här?',
          tooltip: {
            title: 'Hur använder WeTransfer mina uppgifter?',
            p1: 'Vi använder din mejladress för att visa dig (och andra som dig) WeTransfer-annonser på de webbplatser som du besöker, till exempel i sociala medier.',
            p2: 'Vi använder också ditt arbetsfält för att ge dig en bättre upplevelse på våra webbplatser.',
            p3: 'De uppgifter som du väljer att dela med oss hålls alltid helt säkra.',
            button: 'OK',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Lägg till andra till din arbetsyta',
      workspace: 'Arbetsyta',
      manage_workspace: 'Hantera arbetsyta',
    },
  },
  exception: {
    activate_subscription_exception:
      'Hmm, något gick snett. Försök igen eller kontakta oss via vårt <a href="https://wetransfer.zendesk.com" rel="external">hjälpcenter</a>',
    complete_payment_exception:
      'Hmm, något gick snett. Försök igen eller kontakta vårt <a href="https://wetransfer.zendesk.com" rel="external">hjälpcenter</a>.',
    retrieve_checkout_exception:
      'Hmm, något gick snett. Försök igen eller kontakta oss via vårt <a href="https://wetransfer.zendesk.com" rel="external">hjälpcenter</a>',
    source_id_error: 'Tyvärr kunde vi inte behandla din begäran – försök igen.',
    three_d_secure: 'Vi stöder inte 3D Secure-kort för närvarande.',
    something_went_wrong:
      'Hmm, något gick snett. Försök igen eller kontakta vår <a href="https://wetransfer.zendesk.com" rel="external">kundtjänst</a>.',
    signin_no_data_exception:
      'Hmm, något gick snett. Kontrollera ditt användarnamn och lösenord och försök igen.',
    signin_exception: 'Beklagar, men inloggningen misslyckades. Försök igen.',
    signout_exception:
      'Hmm, det verkar som om utloggningen misslyckades. Konstigt. Uppdatera sidan för att se om du fortfarande är inloggad.',
    signup_account_error:
      'Hmm, något gick snett under inloggningen. Kontrollera dina kontouppgifter och försök igen.',
    retrieve_account_exception: 'Hmm, något gick snett. Kan du försöka igen?',
    update_account_error:
      'Det gick inte att uppdatera dina kontouppgifter. Kan du försöka igen?',
    retrieve_subscription_exception:
      'Vi hittade inte din betalningsinformation. Försök igen.',
    update_subscription_exception:
      'Det gick inte att uppdatera din betalningsinformation. Försök igen eller kontakta vår <a href="https://wetransfer.zendesk.com" rel="external">kundtjänst</a>.',
    autorenewal_not_supported:
      'Det här kontot stöder inte automatisk förlängning',
    email_background_upload_validation_error:
      'Filen är för stor eller inte i png- eller jpg-format. Försök med en annan bild.',
    email_background_upload_validation_error_videos:
      'Filen är för stor eller inte i png- eller jpg-format. Försök med en annan bild.',
    update_password_exception:
      'Det gick inte att uppdatera ditt lösenord. Försök igen.',
    retrieve_device_exception:
      'Vi hittade inga ansluta enheter. Inte en enda! Försök igen.',
    remove_device_exception: 'Det gick inte att ta bort den här enheten',
    renew_subscription_exception:
      'Det gick inte att förlänga ditt abonnemang just nu. Försök igen senare.',
    invoices_retrieve_exception:
      'Vi kunde inte hitta dina kvitton. Försök igen.',
    invoice_download_exception:
      'Det gick inte att hämta det här kvittot. Försök igen.',
    image_not_valid: 'Hmm, det går tydligen inte att ladda upp den här bilden.',
    update_profile_error:
      'Hmm, vi kunde inte uppdatera din profil. Försök igen.',
    retrieve_profile_exception:
      'Vi kunde inte hitta dina profilinställningar. Försök igen.',
    s3_exception: 'Hmm, något gick snett med din uppladdning. Försök igen.',
    file_size_limit_reached:
      'Måttlighet är en dygd, som de visa säger – ladda upp en bild på högst 3 MB.',
    retrieve_transferlist_exception:
      'Vi kunde inte hitta din lista med överföringar',
    retrieve_transfer_exception:
      'Vi kunde inte hitta information om överföringsdetaljer',
    delete_transfer_exception: 'Vi kunde inte radera den här överföringen',
    delete_transfers_exception: 'Vi kunde inte radera de här överföringarna',
    update_expiry_exception:
      'Vi kunde inte uppdatera det här tillgänglighetsdatumet',
    add_contact_exception: 'Det gick inte att lägga till kontakten',
    complete_last_order_exception: 'Vi kunde inte slutföra din beställning',
    edit_contact_exception: 'Det gick inte att uppdatera kontakten',
    remove_contact_exception: 'Det gick inte att radera kontakten',
    request_password_reset_exception:
      'Vi kunde inte behandla din begäran om återställning av lösenordet. Försök igen.',
    request_password_reset_no_user:
      'Vi känner inte igen den här e-postadressen. Är du säker på att det är samma e-postadress som du registrerade dig med?',
    reset_password_error:
      'Något gick snett när vi skulle återställa ditt lösenord. Försök igen.',
    reset_password_exception:
      'Det gick tyvärr inte att återställa lösenordet just nu. Försök igen.',
    reset_password_token_invalid:
      'Hmm, den här återställningslänken fungerar inte. Följ instruktionerna i meddelandet vi skickade till dig eller försök igen.',
    retrieve_last_order_exception: 'Vi kunde inte hitta din beställning',
    retrieve_ternot_exception:
      'Hmm, vi har problem med att hitta din överföring. Försök igen.',
    signin_invalid_credentials:
      'E-postadressen och lösenordet överensstämmer inte – kontrollera och försök igen',
    unsubscribe_expiration_exception:
      'Något gick snett när vi skulle avregistrera dig. Försök igen.',
    unsubscribe_expiration_invalid_signature:
      'Hmm, länken för att avregistrera dig fungerade inte. Försök igen.',
    cancel_subscription_exception:
      'Det verkar som någonting gick fel och vi kunde inte annullera din prenumeration. Försök igen senare.',
    payment_cancelled:
      'Hmm, något gick snett. Försök igen eller kontakta vårt <a href="https://wetransfer.zendesk.com" rel="external">hjälpcenter</a>.',
    profile_picture_upload_validation_error:
      'Filen är för stor eller inte i png- eller jpg-format. Försök med en annan bild.',
    reactivate_subscription_exception: 'Något gick snett. Försök igen.',
    retrieve_contactlist_exception:
      'Vi kunde inte hitta din lista över kontakter',
    source_retrieve_error:
      'Hmm, något gick snett. Försök igen eller kontakta vårt <a href="https://wetransfer.zendesk.com" rel="external">hjälpcenter</a>.',
    token_error: 'Något gick fel. Vill du försöka igen?',
    update_user_error:
      'Ett problem inträffade när dina uppgifter skulle uppdateras',
    wallpaper_upload_validation_error:
      'Filen är för stor eller inte i png- eller jpg-format. Försök med en annan bild.',
    wallpaper_upload_validation_error_videos:
      'Hoppsan, det verkar inte som att din video uppfyller våra krav – ge det ett nytt försök',
    declined_contact_bank_error:
      'Vi kunde tyvärr inte behandla denna betalning – kontakta din bank',
    invalid_password: 'Vi känner inte igen ditt lösenord',
    otp_token_invalid:
      'Oj då, det var fel kod eller så är den inte giltig längre',
    projects_load_exception: 'Just nu går det inte att läsa in dina projekt',
    update_information_throttle:
      'Ett problem inträffade när dina uppgifter skulle uppdateras. Ta en paus på %{throttle_time} innan du försöker igen.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Produkter',
        plans_and_pricing: 'Paket och priser',
        pricing: 'Prissättning',
        pro_and_premium: 'WeTransfer Pro och Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Annonsera',
        upgrade: 'Uppgradera',
      },
      name_1_2019: 'Om företaget',
      name: 'Om företaget',
    },
    home: {
      name: 'Hem',
    },
    help: {
      name: 'Hjälp',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Överföringar',
        contacts: 'Kontakter',
        profile: 'Profile',
        account: 'Konto',
        received: 'Mottagna',
        sent: 'Skickade',
        teams: 'Team',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Logga ut',
    signin: {
      name: 'Logga in',
    },
    branding: 'Eget varumärke',
    label: {
      beta: 'Beta',
      new: 'Ny',
    },
    login: 'Logga in',
    logout: 'Logga ut',
    portals: 'Portaler',
    signup: 'Registrera dig',
    features: {
      name: 'Funktioner',
      all: 'Alla funktioner',
      file_sharing: 'För fildelning',
      collaboration: 'För samarbete',
      security: 'För datasäkerhet',
      branding: 'För varumärkesprofilering',
      fast_feedback: 'För snabb feedback',
    },
    referral: 'Värva vänner',
    switcher: {
      create_free_account: 'Lägg till gratis',
      just_you: 'Bara du',
      team: 'Team',
      team_member_count: '%{amountOfMembers} medlemmar',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Hmm, du verkar inte vara ansluten till internet',
        begins_space:
          'Vi kan inte skicka filer vars namn börjar med ett mellanslag. Döp om filen och försök igen.',
        begins_stop:
          'Vi kan inte skicka filer vars namn börjar med en punkt. Döp om filen och försök igen.',
        blocked:
          'Det gick inte att ladda WeTransfer. Du verkar ha blivit spärrad.',
        generic: 'Vi beklagar, men något gick snett under din överföring',
        has_blackslash:
          'Vi kan inte skicka filer vars namn innehåller ett omvänt snedstreck. Döp om filen och försök igen.',
        has_linebreak:
          'Vi kan inte skicka filer vars namn innehåller en radbrytning. Döp om filen och försök igen.',
        incorrect_recipient:
          'Det verkar som att en av e-postadresserna du angav är felaktig',
        incorrect_sender: 'Det tycks vara ett problem med din e-postadress',
        io_error: 'Det finns ett problem med dina filer',
        long_filename:
          'Vi kan inte skicka filer vars namn innehåller fler än 250 tecken. Döp om filen och försök igen.',
        long_message: 'Meddelandet är för långt. Korta ner det lite.',
        missing_default_recipient:
          'Du kan bara skicka mer än %{free_transfer_limit} till en e-postadress som är registrerad för WeTransfer Pro. Uppdatera sidan för att börja om.',
        no_clipboard: 'Det verkar inte som om du har kopierat länken',
        no_files: 'Du har inte lagt till några filer än!',
        no_folders:
          'Du måste zippa/komprimera din mapp innan vi kan skicka den',
        no_recipient:
          'Vi behöver veta till vilken e-postadress du vill skicka dina filer',
        no_sender:
          'Nu behöver vi bara din e-postadress för att avsluta det här',
        too_big:
          'Ta det lilla lugna! Vi kan inte överföra mer än %{upload_limit} i taget.',
        too_many_recipient:
          'Hoppsan! %{count} personer är vår gräns. Du ska inte skapa en länk till överföringen istället?',
        unavailable:
          'Beklagar, men den här överföringen har raderats och är inte längre tillgänglig',
        wrong_password:
          'Hmm, lösenordet stämmer inte. Försök igen eller prata med personen som gjorde överföringen till dig.',
        default_title: 'Hoppsan!',
        duplicate_filename:
          'Vi kan inte skicka flera filer med samma namn. Döp om dem och försök igen.',
        firstaccept: 'Du behöver godkänna åtgärden innan du kan skicka',
        not_downloadable:
          'Ett fel uppstod när filerna skulle hämtas. Uppdatera sidan och försök igen.',
        recaptcha: {
          text: 'Något gick fel. Försök igen!',
          title: 'Oj då …',
        },
        too_big_text:
          'Du kan inte skicka mer än %{upload_limit} åt gången. Skicka upp till %{plus_limit} med Pro. ',
        too_big_title: 'Gillar du att skicka stora filer?',
        too_many_files: 'Du kan inte skicka fler än %{count} filer åt gången',
        too_many_recipient_text:
          'Med Pro kan du skicka filer till upp till 50 personer.',
        too_many_recipient_title: 'Det är för många människor',
        unavailable_forward:
          'Det ser ut som om den här överföringen har tagits bort så den kan tyvärr inte vidarebefordras',
        verify: {
          button: 'Ny kod tack!',
          text: 'Försök igen eller begär en ny kod. ',
          title: 'Hoppsan!',
        },
      },
      buttons: {
        check_out: 'Se själv!',
        help: 'Hjälpcenter',
        plus: 'Skaffa Pro',
        get_link: 'Hämta länk',
      },
      tips: {
        change_type:
          'Skicka filer via e-post eller skapa en särskild överföringslänk som du kan dela precis hur du vill',
        contacts:
          'Alla som du skickar filer till kommer automatiskt att läggas till i dina kontakter',
        expiry:
          'Med WeTransfer Pro kan du bestämma hur länge överföringar ska vara tillgängliga. (Du kan till och med ändra slutdatumet när en överföring redan har skickats!)',
        free_limit:
          'Goda nyheter: Du kan skicka upp till %{size} i taget. Ännu godare nyheter: Du kan använda tjänsten så ofta du vill!',
        message:
          'Du kan välja att lägga till ett meddelande här som kommer att skickas tillsammans med din överföring',
        password:
          'Du kan skydda en överföring med ett lösenord för extra säkerhet. Tänk på att vi inte lägger till lösenordet i meddelandet så du måste ge det till rätt personer!',
        recipient_limit:
          'Lägg till upp till %{email_limit} mejladresser eller öppna menyn bredvid överföringsknappen för att skapa en länk',
        transfer_history: 'Överföringen har sparats i din överföringsöversikt',
        your_email:
          'Skriv din egen e-postadress här så att vi kan berätta för dig när dina filer har hämtats',
        link_transfer:
          'Visste du att du kan hämta länken till din överföring här?',
        previews_receiver:
          'Bilder som skickas från Pro-användare kan förhandsvisas innan de hämtas. Klicka på en för att att se vad som finns inuti!',
        previews_sender:
          'Bilder du kan skicka kan nu förhandsvisas innan de hämtas',
        vrl_text: 'Du kan nu ta en titt på filerna utan att behöva hämta dem.',
        vrl_title: 'Förhandsgranska filer',
        zip_text: 'Skickar du en mapp? Vi zippar den åt dig',
        zip_title: 'Du behöver inte skapa zip-filer',
        add_display_name_tooltip:
          'Ge din överföring en titel så att folk vet vad filerna handlar om. Det gör det också lättare att hitta den senare.',
        anonymous_sender: {
          button: 'Hämta en länk',
          text: 'Knappa in din mejladress så att vi kan berätta när dina filer hämtas.\n\nDu kommer att behöva verifiera din mejladress så att vi vet att du är du. Vill du inte verifiera varje gång?',
          text_locked_recipient:
            'Knappa in din mejladress så att vi kan berätta när dina filer hämtas.\n\nDu kommer att behöva verifiera din mejladress så att vi vet att du är du.',
        },
        prefer_link: {
          button: 'Hämta en länk',
          text: 'Vill du inte verifiera din mejl? Det är okej.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Läs mer',
        previews_sender_learnmore: 'Läs mer',
      },
      recipient_locked_text:
        'Den här sidan är till för att ägaren ska kunna ta emot filer. Logga in om det är du eller gå till <a href="https://wetransfer.com"> wetransfer.com</a> för att skicka till någon annan.',
      recipient_locked_title: 'Bara så att du vet',
      title: {
        previews_receiver: 'Nytt: förhandsvisa bilder',
        previews_sender: 'Nytt: förhandsvisa bilder',
      },
    },
    download: {
      blocked: {
        link: 'Läs mer',
        text: 'Den här överföringen har rapporterats och kan inte hämtas',
        title: 'Överföring blockerad',
      },
      title: 'Börja när du vill',
      expires: 'Överföringen är tillgänglig %{relative_time} till',
      expires_never: 'Tillgänglig tills vidare',
      files: '%{count} filer, %{size}',
      format: '%{files}・ %{expires}',
      expand: 'mer',
      download_link: 'Hämtningslänk',
      files_nosize: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      show_all_files_mobile: 'Visa samtliga filer',
      zip_information:
        'Du kommer att motta en zipfil när du hämtar alla filer på en gång. <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">Läs mer.</a>',
      files_label: 'Filer',
      message: 'Meddelande',
      learn_more: 'läs mer',
      expires_in: 'Upphör om %{expiry}',
      download_all_zip: '"Hämta alla" kommer att hämta alla filer som en .zip',
      back_to_transfer: 'Tillbaka till överföringar',
      cookie_text:
        'Vi använder cookies för att ge dig den bästa upplevelsen. Du behöver inte vara orolig – vi säljer inte dina uppgifter till tredje part. Hantera dina <a href="https://wetransfer.com/legal/manage-cookies" rel="external">uppgiftsinställningar</a>.',
    },
    preview: {
      open_grid: 'Förhandsgranskning',
      click_to_open: 'Klicka för förhandsvisning',
      grid: 'Filer i denna överföring',
      link: 'Webbplats',
      not_previewable: 'Visning ej möjlig',
      now_open: 'Visa och öppna',
      open_link: 'Öppna länken i en ny flik',
      open_link_short: 'Öppna länk',
      overview: 'översikt',
      reload: 'Klicka här för att läsa in igen',
      something_went_wrong: 'Hoppsan, något gick fel',
      tap_to_open: 'Förhandsvisning',
      toobig_copy:
        'Vi kan endast förhandsgranska bilder upp till 50MB – <a href="https://wetransfer.zendesk.com/" rel="external">läs mer här</a>',
      toobig_title: 'Ajdå–bilden är för stor för att förhandsgranska',
      unsupported_copy:
        'Kolla in <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">den här artikeln</a> för att se vilka filer vi kan förhandsvisa',
      unsupported_title: 'Vi kan inte förhandsvisa den här filen (än)',
      visit_website: 'Besök webbplatsen',
    },
    complete_mobile: {
      email_text:
        'Överföringsmejlet har skickats – din överföring är tillgänglig i %{expires}',
      link_text: 'Kopiera din hämtningslänk:',
      email_text_no_expiry: 'Ett mejl har skickats till mottagaren.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>Visste du att 30 % av vårt annonseringsutrymme går till konstnärer?</b> Om du godkänner våra kakor kan vi visa upp lite konst, lyfta fram viktiga ämnen som vi brinner för och en och annan prisvinnande annons som inte är påträngande. ',
          text: 'Godkänner du även kakor från tredjepartsannonsörer så att vi kan personanpassa annonserna åt dig? ',
          title: 'Vi matar konstnärer med kakor',
        },
        subtitle:
          '<b>Därför går 30 % av vårt annonsutrymme till konstnärer.</b> Om du godkänner våra kakor kan vi visa upp lite konst, lyfta fram viktiga ämnen som vi brinner för och en och annan prisvinnande annons som inte är påträngande. ',
        text: 'Vi använder kakor för att vår webbplats ska kunna fungera ordentligt, för att kunna analysera hur du interagerar med den och för att förbättra dess prestanda. Godkänner du även cookies från tredjepartsannonsörer så att vi kan personanpassa annonserna åt dig?',
        title: 'Vi vet att konst kan försätta berg',
        'title-small': 'Välkommen till WeTransfer',
      },
      'button-accept': 'Jag godkänner',
      'button-accept-all': 'Godkänn alla',
      'button-ccpa': 'Tacka nej till försäljning av personuppgifter',
      'button-cookies-privacy': 'Dina integritetsval',
      'button-reject': 'Nej tack',
      'button-save': 'Spara',
      'button-save-and-exit': 'Spara och stäng',
      'ccpa-banner-text':
        'Vi använder cookies för att se till att du får bästa tänkbara upplevelse på vår webbplats. Du behöver inte vara orolig – vi säljer inte dina uppgifter till tredje part. Vill du ändå tacka nej? <a href="%{href}">Hantera inställningar</a>',
      'ccpa-body':
        'Eftersom du befinner dig i USA skyddas dina rättigheter av California Consumer Privacy Act (CCPA), och du kan be oss att sluta sälja dina personuppgifter. Det betyder dock inte att vi annars skulle auktionera ut dina personuppgifter eller privata filer till högstbjudande – det har vi aldrig gjort, och kommer aldrig att göra. Vi arbetar hårt för att hålla ditt digitala fotavtryck litet, säkert och under din egen kontroll. Du kan läsa mer om vilka uppgifter vi samlar in och varför under <a href="%{href}">Dina integritetsval</a>.',
      'ccpa-donotsell': 'Sälj inte mina personuppgifter',
      'ccpa-header': 'Tacka nej till försäljning av personuppgifter',
      'ccpa-intro':
        'Som ett ansvarsfullt teknikföretag som satsar på att skapa ett bättre internet säljer vi inte dina uppgifter till tredje part. Men du har ändå rätt att officiellt tacka nej.',
      'ccpa-variant-test-text':
        'Vi använder kakor för att se till att du får en sömlös upplevelse på vår webbplats och för att anpassa annonserna du ser. <a href="%{href}">Manage cookies</a>',
      headline: 'Kakor och annonser',
      intro:
        'Vi använder pengarna vi får från våra vackra annonser för att hjälpa till att betala våra räkningar. Det är så vi får råd att tillhandahålla fildelningstjänsten gratis.',
      'manage-cookies': 'Hantera kakor',
      'partners-consent': 'Samtycke',
      'partners-features': 'Egenskaper',
      'partners-headline': 'Våra partners',
      'partners-text':
        '<p>Här är en alfabetisk lista över de noggrant utvalda partners som vi tillåter att mäta dina data så att vi kan spåra och förbättra prestanda.</p>',
      'preferences-headline': 'Hantera kakor ',
      'preferences-text':
        '<p>Vi respekterar din rätt till integritet och dina val angående dina uppgifter. Vi måste bearbeta en del av din personliga information när du använder våra verktyg, men för oss är det viktigt med en ansvarsfull och värderingsinriktad strategi för affär, teknik och vår relation med dig.</p>\n<p>Det är därför vi gör mycket för att hålla ditt digitala fotavtryck litet, säkert och under din kontroll.</p>\n<p>Som standard samlar och bearbetar vi bara data när det är absolut nödvändigt. Men om du vill stödja vår tjänst och behålla WeTransfer gratis, ber vi dig att låt oss dela information med våra annonspartners.</p>',
      'preferences-text-allow-cookies':
        'Tillåt kakor så att vi och/eller våra partners kan:<br><br>',
      'purpose-description-first-intro':
        'För att marknadsföra produkter på och utanför vår webbplats och appar kan WeTransfer: ',
      'purpose-description-first-list':
        '<ul><li>Samla in information om hur du interagerar med vår/våra webbplats(er), till exempel klickbeteende och besökta sidor, och (när det är möjligt) kombinera denna information med data som vi har sparat om dig, till exempel din e-postadress som är kopplad till ditt konto</li><li>Använda informationen vi samlar in för att skicka dig erbjudanden och kampanjer via e-post; på vår egen/egna webbplats(er) eller appar; och på webbplatser eller appar från tredje part. Vi kan till exempel marknadsföra en av våra andra produkter till dig när du använder WeTransfer Pro.</li></ul>',
      'purpose-description-second-intro':
        'För att marknadsföra produkter på och utanför vår webbplats och appar kan våra partners: ',
      'purpose-description-second-list':
        '<ul><li>Samla in information om hur du interagerar med vår/våra webbplats(er), till exempel klickbeteende och besökta sidor, och (när det är möjligt) kombinera denna information med data de har sparat om dig</li><li>Använda informationen de samlar in för att skicka dig erbjudanden och kampanjer via e-post; på sin/sina egna webbplats(er) eller appar; och på webbplatser eller appar från tredje part de arbetar med.</li></ul>',
      'purpose-title':
        'Marknadsför produkter på och utanför vår webbplats och appar',
      'switch-by-partners': 'Av partners',
      'switch-by-we-transfer': 'Av WeTransfer',
      text: '<p>Vår webbplats använder <a href="%{href}">kakor</a>som ser till att den fungerar, hjälper oss att analysera sätter vi interagerar med dig och hjälper oss att förbättra vår prestanda.</p>\n<p>Vill du också tillåta kakor från våra annonspartners så att vi kan anpassa annonserna du ser, samt marknadsföra produkter från WeTransfer och våra partners på och utanför våra webbplatser och appar?</p>',
      'text-panel':
        '<p>Vår webbplats använder kakor som ser till att den fungerar, hjälper oss att analysera sätter vi interagerar med dig och hjälper oss att förbättra vår prestanda.</p>\n<p>Vill du också tillåta kakor från våra annonspartners så att vi kan anpassa annonserna du ser, samt marknadsföra produkter från WeTransfer och våra partners på och utanför våra webbplatser och appar?</p>',
      'tos-experiment': {
        'cookie-intro':
          'Det enklaste sättet att skicka stora filer samtidigt som du ser fantastisk konst och prisvinnande annonser.',
        'cookie-text':
          'Vi använder kakor för att vår webbplats ska kunna fungera ordentligt, för att kunna analysera hur du interagerar med den och för att förbättra dess prestanda. \nOm du godkänner våra kakor kan vi visa personanpassade annonser. Sa vi ordet kakor tillräckligt många gånger? (Kakor, mmm …)',
      },
      trees: {
        'short-v': {
          subtitle:
            'Vår mission är att göra världen vackrare med diskreta, prisvinnande annonser som gör att vi kan skänka pengar till arbetet med att återskapa förstörda ekosystem under havet.',
          title: 'Våra kakor skyddar planeten',
        },
        subtitle:
          'Genom att godkänna kakor hjälper du oss att förändra världen. Bara i år har WeTransfer gett ett löfte om att plantera över 175 000 träd och det är bara början. Du påverkar världen i positiv riktning bara genom att se våra prisvinnande annonser. ',
        text: 'Vår webbplats använder kakor för att förbättra prestandan, tjänsten och för att bättre förstå dina behov. Genom att godkänna kakor från tredje part kan vi och våra partners erbjuda relevantare annonser på och utanför våra webbplatser och i våra appar.',
        title: 'Skapa idéer. <b>Skapa en bättre värld.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Lås upp Collect Pro',
      title: 'Spara och dela inspiration på språng',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Berätta mer',
      title: 'Paste® Pro och Collect Pro ingår nu i din prenumeration',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Lås upp Paste® Pro',
      title: 'Förvandla stora idéer till vackra presentationer',
    },
    terms_conditions: {
      experiment: {
        text: 'Du behöver godkänna våra <a href="/legal/terms" data-route-type="plus">användarvillkor</a> innan du fortsätter.',
        title: "Nu är du <span class='tc-title-exp'>nästan</span> klar",
        ustitle:
          "Välkommen till det enklaste sättet att <span class='tc-title-exp'>skicka stora filer.</span>",
      },
      title: 'Men först …',
      text: 'Du behöver godkänna våra <a href="/legal/terms" data-route-type="plus">användarvillkor</a> och vår <a href="/legal/privacy" data-route-type="plus">kakpolicy</a>. Kakor används av funktionella och analytiska skäl och tredjepartskakor för annonser.',
      language: 'Språket är inställt på',
      button: 'Jag godkänner',
    },
    upsell_pricing: {
      text: 'Jämför paket',
      title: 'Vill du skicka större överföringar?',
      receiving: {
        title: 'Vill du få ut så mycket som möjligt att WeTransfer?',
      },
    },
    welcome: {
      card1:
        'Skicka och ta emot %{transfer_limit} överföringar med en <strong>delad översikt</strong>',
      card2:
        'Leverera arbete från ditt teams <strong>egen WeTransfer-sida</strong>',
      card3:
        'Samarbeta med presentationer i <strong>Paste</strong> och tavlor i <strong>Collect</strong>',
      cta: 'Kom igång',
      headline: 'Du är en i laget, <strong>%{first_name}!</strong>',
      'opt-in':
        'Jag vill höra berättelser om kreativitet och de senaste nyheterna från WeTransfer',
    },
    form: {
      num_files: {
        one: '%{count} fil tillagd · %{remaining} kvar',
        other: '%{count} filer tillagda · %{remaining} kvar',
      },
      add_files: 'Ladda upp filer',
      more_files: 'Lägg till fler filer',
      available_space: 'Lägg till upp till %{size}',
      message: 'Meddelande',
      from: 'Din e-postadress',
      to: 'Skicka till',
      other_recipients: {
        one: '+%{count} annan',
        other: '+%{count} andra',
      },
      reset_forward: 'Avbryt den här vidarebefordringen',
      drop_files: 'eller dra och släpp',
      files_count: {
        one: '%{count} fil tillagd · %{fileSize} totalt',
        other: '%{count} filer tillagda · %{fileSize} totalt',
      },
      select_folder: 'Eller välj en mapp',
    },
    progress: {
      title: 'Överför …',
      title_cancel: 'Avbryt den här överföringen?',
      uploaded: '%{sent} av %{total} uppladdade',
      remaining: {
        minutes: {
          zero: 'Mindre än 1 minut återstår',
          one: 'Ungefär 1 minut återstår',
          other: 'Ungefär %{count} minuter återstår',
        },
        hours: {
          one: 'Ungefär 1 timme återstår',
          other: 'Ungefär %{count} timmar återstår',
        },
      },
      document_title: '%{percentage}% – Överför …',
      meta: {
        email: {
          one_file_one_recipient:
            'Skickar %{filesCount} fil till %{recipientsCount} person',
          one_file_other_recipients:
            'Skickar %{filesCount} fil till %{recipientsCount} personer',
          other_files_one_recipient:
            'Skickar %{filesCount} filer till %{recipientsCount} person',
          other_files_other_recipients:
            'Skickar %{filesCount} filer till %{recipientsCount} personer',
        },
        link: {
          one: 'Skickar %{count} fil',
          other: 'Skickar %{count} filer',
        },
      },
    },
    complete_link: {
      title: 'Klart!',
      text: 'Kopiera en hämtningslänk eller <a href="/transfer/progress">ta en titt på innehållet</a>',
      text_copied: 'Länken har kopierats till urklipp',
      text_manual_copy:
        'Länken är redo \nTryck på %{shortcut} för att kopiera den till urklipp',
      document_title: 'Klart!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Din överföring har vidarebefordrats',
    },
    complete_email: {
      title: 'Klart!',
      text: 'Överföringsmejlet har skickats – din överföring är tillgänglig i %{expires}. <a href="/transfer/progress">Ta en titt på innehållet</a>',
      text_no_expiry:
        'Överföringsmejlet har skickats. <a href="/transfer/progress">Ta en titt på innehållet</a>',
      document_title: 'Skickat!',
      text_no_details:
        'Överföringsmejlet har skickats – din överföring är tillgänglig i %{expires}.',
      team_discovery_title: 'Överföring skickades!',
      team_discovery_text:
        'Din överföring kommer att vara tillgänglig för nedladdning i %{expires}',
    },
    failed: {
      title: 'Hmm, något gick snett',
      text: 'Det ser ut som att överföringen misslyckades. Försök igen.',
    },
    pending: {
      title: 'Vi arbetar på saken …',
      subtitle: 'Förbereder …',
    },
    downloading: {
      title: 'Hämtar dina filer …',
      text: 'Vi håller på att förbereda din hämtning',
    },
    downloaded: {
      title: 'Din hämtning har startat',
      text: 'När hämtningen är klar lagras filerna på din dator (vanligtvis i mappen Hämtade filer)',
      download_links:
        'Tänk på att länkarna i din Board inte visas – <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">läs mer här</a>.',
    },
    expired: {
      title: 'Överföringen är inte tillgänglig längre',
      text: 'Beklagar, men den här överföringen är inte tillgänglig längre',
    },
    password: {
      title: 'Ange lösenord',
      text: 'Du måste ange ett lösenord för att hämta den här överföringen',
    },
    options: {
      transfer_type: 'Skicka som',
      password: 'Lösenord',
      password_placeholder: 'Välj lösenord',
      expiry: 'Tillgänglig',
      expire_in: {
        '1w': '1 vecka',
        '2w': '2 veckor',
        '1m': '4 veckor',
        never: 'Aldrig',
        '14d': '2 veckor',
        '28d': '4 veckor',
        '365d': '1 år',
        '7d': '1 vecka',
        '90d': '3 månader',
      },
      email: 'e-post',
      link: 'länk',
      email_transfer: 'Skicka mejlöverföring',
      transfer_link: 'Hämta överföringslänk',
    },
    buttons: {
      transfer: 'Överför',
      forward: 'Vidarebefordra',
      new_transfer: 'Skicka en fil?',
      cancel: 'Avbryt',
      cancel_no: 'Nej',
      cancel_yes: 'Ja',
      copy_link: 'Kopiera länk',
      ok: 'OK',
      done: 'Skicka en till?',
      team_discovery_done: 'Skicka ny överföring',
      retry: 'Försök igen',
      continue: 'Fortsätt',
      download: 'Hämta',
      download_all: 'Hämta alla',
      back_to_home: 'Tillbaka till startsidan',
      cleanup: 'Se överföringar ',
      download_all_files: 'Hämta samtliga filer',
      help: 'Hjälpcenter',
      payment: 'Förläng nu',
      complete_order: 'Gå till kassan',
      download_all_experiment: 'Hämta alla som en .zip',
      download_experiment: 'Hämta fil',
      download_file: 'Hämta fil',
      download_zip: 'Hämta alla som .zip',
      get_link: 'Hämta länk',
      go_to_transfer: 'Gå till överföring',
      openinapp: 'Spara med WeTransfer-appen',
      openinapp_experiment: 'Spara med WeTransfer-appen',
      openincollectapp: 'Spara med Collect-appen',
      get_a_link: 'Hämta en länk',
    },
    account_expired: {
      text: 'Förläng nu för att fortsätta dra nytta av fördelarna med ett Pro-abonnemang, eller <a href="#signout">avregistrera dig för att använda vår kostnadsfria tjänst</a>',
      title: 'Pro-kontot har upphört',
    },
    invalid: {
      text: 'Vi hittade inte dina filer',
      title: 'Hoppsan …',
      link: 'Läs mer',
    },
    outdated_browser: {
      text: 'WeTransfer stöder en mängd olika webbläsare men din tycks inte vara uppdaterad. Du behöver uppdatera din webbläsare för att kunna använda WeTransfer.',
      title: 'Din webbläsare är inte uppdaterad',
    },
    spam: {
      text: 'Överföringen har rapporterats som skräppost och har raderats',
      title: 'Hmm …',
    },
    upsell: {
      text: 'Increase limit',
      limit: 'Up to %{limit} free',
      remaining: '%{remaining} remaining',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Hämta WeTransfer Pro',
      title: 'Lösenordsskyddade överföringar för extra sinnesro',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Skaffa WeTransfer Pro',
      title: 'Ett smartare och enklare sätt att hantera dina överföringar',
    },
    upsell_one: {
      bubble: {
        button: 'Skaffa Pro',
        text: 'Lösenordsskydda dina överföringar och bestäm hur länge de ska vara tillgängliga',
        title: 'Uppgradera överföring?',
        text_experiment:
          'Med Pro kan du ange lösenord och välja hur länge överföringar ska vara tillgängliga.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer på Facebook',
      title: 'Följ WeTransfer på Facebook',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Skaffa WeTransfer Pro',
      title: 'Skräddarsy din WeTransfer-profil',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Skaffa WeTransfer Pro',
      title: 'Bli större, bättre, starkare och snabbare',
    },
    account_inactive: {
      text: 'Slutför din registrering för att komma igång med Pro',
      title: 'Ditt konto är\ninte aktivt än',
      tiers: {
        text: 'Slutför din betalning för att komma igång med %{plan}.',
        title: 'Din prenumeration är inte aktiv ännu',
      },
    },
    add_items: {
      files: 'Filer',
      folders: 'Mappar',
    },
    complete: {
      open_panel:
        '<a href="/transfer/progress">Vill du ta en titt på innehållet</a>?',
    },
    details: {
      button: {
        dismiss: 'Avvisa',
      },
    },
    download_preview: 'Hämta fil',
    error: {
      expired: {
        link: 'Kontakta vårt supportteam.',
        text: 'Attans. Det ser ut som att tiden för din överföring redan har gått ut.\nVerkar det inte rätt?',
        title: 'Överföringstiden har gått ut',
      },
    },
    item: {
      details: {
        folder: 'Mapp',
      },
    },
    items: {
      zero: 'tomt',
      one: '%{count} objekt',
      other: '%{count} objekt',
    },
    mobile: {
      button: {
        back: 'Tillbaka',
        cancel: 'Börja om',
        next: 'Nästa',
      },
      email: {
        title: 'Lägg till e-postadresser',
      },
      message: {
        placeholder: 'Lägg till ett meddelande till din överföring',
        title: 'Meddelande',
      },
      options: {
        email: 'Skicka ett mejl',
        'email-description':
          'Skicka din överföring med ett mejl så hör vi av oss när den har hämtats.',
        link: 'Hämta en länk',
        'link-description':
          'Förvandla dina filer till en länk och dela den hur du vill.',
      },
    },
    recaptcha: {
      button: 'Jag är mänsklig',
      text: 'Vi behöver bara kontrollera så att du inte är en robot (ta det inte personligt)',
      title: 'Du är nästan klar!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Hjälp oss',
      title: 'Får vi ställa en fråga om ditt sätt att arbeta?',
    },
    'verification-code': 'Verifieringskod',
    verify: {
      button: 'Starta överföring',
      text: 'Kolla om en verifieringskod har trillat ner i inkorgen och ange den nedan',
      title: 'Du har fått mejl',
      'verification-code': 'Verifieringskod',
    },
    'account-verification-failed': {
      body: 'Vi har problem med att bekräfta din mejladress. Skicka en ny länk för att ge det ett nytt försök.',
      cta: 'Skicka en ny länk?',
      title: 'Något gick fel',
    },
    'cookie-banner': {
      'button-accept': 'Okej',
      'button-decline': 'Nix',
      text: 'Vi använder <a href="%{href}">kakor</a> som hjälper webbplatsen att fungera, gör att vi kan analysera hur våra användare interagerar med den och hjälper oss att förbättra den. Vill du tillåta kakor från tredje part så att du ser personanpassade annonser?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Vi använder analyscookies som hjälp för att förstå hur du använder WeTransfer. Dessa cookies ger oss möjlighet att A/B-testa nya funktioner, se till att allt fungerar som det ska och sätta stopp för bottar och skadligt beteende som skräppost. Dessa cookies kan omfatta tredjepartscookies som behandlar personuppgifter. ',
        title: 'Analyscookies',
      },
      clear: {
        'clear-all-cookies': 'Rensa alla cookies',
        description:
          'Du kan ta bort alla dina data från våra cookies. Om du vill begära permanent anonymitet ber vi dig att <a href="mailto:support@wetransfer.com">kontakta vårt supportteam.</a>',
        title: 'Rensa cookies',
        warning:
          'Efter att du har rensat cookies loggas du ut från WeTransfer. Överföringar på ditt konto påverkas inte.',
      },
      functional: {
        description:
          'Vi använder funktionscookies för att ge dig en sömlös upplevelse på WeTransfer. Dessa cookies krävs för att kunna använda vår tjänst.',
        title: 'Funktionscookies',
      },
      'not-yet-set':
        'Du verkar inte ha meddelat oss dina cookiepreferenser ännu. Stäng den här panelen och ställ in dina preferenser. Du kan alltid ändra dem här senare.',
      'save-and-reload': 'Spara inställningar',
      tracking: {
        description:
          'Vi använder annonscookies i vår tjänst för att hjälpa oss att mäta resultatet av vårt kommersiella, redaktionella och marknadsföringsmässiga arbete. Annonscookies placeras inte på sidor som informerar om våra varumärken och produkter. Genom annonscookies kan vi till exempel registrera att du har klickat på en viss annons. Om cookies som placeras ut av tredje part även placeras ut på andra domäner och webbplatser kan det hända att annonsören kan följa ditt beteende på internet. WeTransfer kan dock inte komma åt eller använda några av de personuppgifter som eventuellt samlas in. Därför ber vi dig att granska relevanta tredjeparters integritetspolicyer.',
        title: 'Annonscookies',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Hoppsan, något gick fel',
        'error-email-exists':
          'Hoppsan, den här mejlen verkar redan vara upptagen',
        'throttle-error':
          'Hoppla, nu har vi skickat för många mejl till dig. Vänta %{throttle_time} innan du begär en ny kod.',
      },
      back: 'Tillbaka till kodverifiering',
      body: 'Stämmer det här? Det här är mejladressen som du använder på WeTransfer.',
      email: 'Mejl',
      error: 'Hoppsan, något gick fel',
      'error-email-exists': 'Hoppsan, den här mejlen verkar redan vara tagen',
      submit: 'Skicka igen',
      'throttle-error':
        'Tyvärr, du har försökt för många gånger. Starta din överföring igen.',
      'throttle-error-action': 'Starta igen',
      'throttle-error-link':
        'Hoppla, nu har vi skickat för många mejl till dig. Vänta %{throttle_time} innan du begär en ny e-post.',
      title: 'Kolla din mejl',
    },
    'email-verification-success': {
      body: 'Nu kan folk vara säkra på att dina överföringar kommer från dig.',
      free_signup: 'Skapa ett gratiskonto',
      onboarding_body:
        'High five, nu är du med! Redan att välja en egen URL och egna bakgrundsbilder?',
      onboarding_title: 'Välkommen till<br/>WeTransfer Pro!',
      send_files: 'Skicka filer',
      start_onboarding: 'Då kör vi',
      title: 'Ditt konto har verifierats!',
      upsell: 'Vill du inte verifiera din mejladress varje gång?',
      verified_sender_tooltip:
        'Din e-postadress är verifierad, så att andra kan känna sig säkra på att det är du som har skickat överföringarna. Om du vill ändra e-postadressen kan du uppdatera dina <a href="%{href}">personuppgifter</a>.',
      verified_sender_tooltip_icon:
        'Du har verifierat din mejladress. Det innebär att andra kan lita på överföringar som du skickar.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Oj då. Det var fel kod eller så har den löpt ut. Koder är bara aktiva i %{expiry_time} efter att ha skickats.',
        'error-expiry-time-action': 'Hämta ny kod',
        'throttle-error':
          'Du har angett fel kod eller en kod som har löpt ut för många gånger. Vänta %{throttle_time} innan du begär en ny kod.',
      },
      back: 'Gå tillbaka',
      body: 'Vi har skickat en verifieringskod till <strong title="%{account_email}">%{account_email}</strong> för att vara säkra på att du verkligen är du. (Glöm inte att titta efter i skräppostmappen.)',
      body_link:
        'Bara en snabbkoll för att se att du är du.<br/><br/>Vi skickade precis en verifieringslänk till <strong title="%{account_email}">%{account_email}</strong> (kolla skräpposten om du inte ser den).',
      error: 'Oj då, det var fel kod eller så är den inte giltig längre',
      'error-expiry-time':
        'Oj då. Det var fel kod eller så har den löpt ut. Koder är bara aktiva i %{expiry_time} efter att ha skickats.',
      'error-expiry-time-action': 'Hämta ny kod',
      resend: 'Fick du inget mejl?',
      submit: 'Verifiera',
      'throttle-error':
        'Tyvärr, du har försökt för många gånger. Starta din överföring igen.',
      'throttle-error-action': 'Starta igen',
      title: 'Bekräfta din mejladress',
      'verification-code': 'Ange verifieringskod',
    },
    'force-account-verification': {
      body: 'Vi kommer att skicka en länk för att bekräfta mejladressen som du använder på WeTransfer.',
      cta: 'Skicka mejl',
    },
    'marketing-email-prompt': {
      body: 'En sak till: Vill du höra om nyheter och produktuppdateringar från WeTransfer?',
      skip: 'Nej tack',
      subscribe: 'Ja, hör av er',
      title: 'Du är verifierad!',
    },
    'terms_conditions-no-cookies': {
      text: 'För att kunna gå vidare behöver godkänna våra <a href="/legal/terms?from_home" data-route-type="plus">användarvillkor</a>.',
    },
    mobile_web: {
      ios_banner_prompt: 'Skaffa dina filer i WeTransfer-appen',
      ios_banner_prompt_send: 'Skicka filer snabbt och enkelt',
      tnc_subtitle: 'Det enklaste sättet att skicka stora filer',
    },
  },
  account: {
    legend: {
      plan: 'Paket',
      save: 'spara %{amount} %',
      subscription: 'Prenumeration',
      summary: 'Beställningssammanfattning',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Varför vi ber dig att bekräfta din mejl',
    workspace: {
      default_workspace: 'Arbetsyta för %{name}',
      your_workspace: 'Din arbetsyta',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Dina integritetsval',
        subtitle: 'Hantera dina uppgifter',
        p1: 'Vi vill alltid ge dig bästa tänkbara upplevelse, och det gäller även våra annonser.',
        p2: 'Vi vill gärna använda de uppgifter som du väljer att dela, till exempel din mejladress, för att förstå vilken typ av innehåll du gillar bäst och använda det för att visa dig (och andra som dig) WeTransfer-annonser som är skräddarsydda efter dina behov.',
        p3: 'Allt du skapar och delar genom WeTransfer förblir privat – det läser vi inte, och använder det inte heller i annonseringssyfte.',
        p4: 'Om du väljer att dela information med oss hålls den alltid helt säker.',
        control_label:
          'Låt WeTransfer använda de uppgifter som du delar, till exempel din mejladress och ditt arbetsfält, för att skräddarsy annonser för dig på och utanför våra webbplatser.',
      },
      vertical_nav: {
        terms_of_service: 'Användarvillkor',
        privacy_and_cookie_statement: 'Sekretess- och cookiemeddelande',
        your_privacy_choices: 'Dina integritetsval',
        notice_and_takedown_policy: 'Policy för anmälan och borttagning',
        responsible_disclosure_policy: 'Policy för ansvarsfullt avslöjande',
        advertising_terms_and_conditions: 'Annonseringsvillkor',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Stäng och börja skicka filer',
  },
  account_start_screen: {
    'collect-description':
      'Spara all inspiration på en och samma plats, oavsett om det är från telefonen, datorn eller surfplattan.',
    'collect-title': 'Gå till Collect',
    'paste-description':
      'Skapa vackra bilder på några sekunder med presentationer som designar sig själva.',
    'paste-title': 'Gå till Paste®',
    title: 'Tre verktyg. Ett konto. Oändliga möjligheter.',
    'transfer-cta': 'Då kör vi',
    'transfer-description':
      'Ge ett gott intryck varje gång någon hämtar dina filer. Redo att välja din egen URL och dina egna bakgrundsbilder?',
    'transfer-title': 'Skapa din egen WeTransfer-sida',
  },
  account_welcome_screen: {
    'pro-title': 'Välkommen till WeTransfer Pro, <strong>%{name}!</strong>',
    accept: 'Ja, tack',
    'accept-short': 'Okej',
    body_1:
      'Vill du höra berättelser om kreativitet och de senaste nyheterna från WeTransfer?',
    body_2: '(Du kan alltid avsluta prenumerationen senare.)',
    decline: 'Nej, tack',
    'decline-short': 'Nej tack',
    title: 'Välkommen till WeTransfer <strong>%{name}!</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Godkänn cookies',
      deny: 'Neka cookies',
      manage: 'Hantera cookies',
    },
    description:
      'Vi använder vanliga cookies och analyscookies för att erbjuda en jättebra upplevelse, och tredjepartscookies för annonsering.',
    heading: 'Upptäck det enklaste sättet att skicka stora filer',
    snippet: 'Välkommen till WeTransfer',
  },
  dropzone: {
    pro: {
      title: '<span>Släpp</span> dem<br>som om du bränt dig',
    },
    title: 'Släpp dem som om du bränt dig',
    text: 'Ladda upp filer eller mappar genom att dra och släppa dem i det här fönstret',
  },
  form: {
    account: {
      billing_address: 'Faktureringsadress',
      billing_cta: 'Gå till betalning',
      billing_title: 'Faktureringsinformation',
      legend: {
        details: 'Din faktureringsinformation',
        coupon_code: 'Lägg till en rabattkod',
        free_plus: 'Skapa ett Pro-konto kostnadsfritt',
      },
      label: {
        year_label: 'Per år',
        year_sublabel: 'Mest prisvärt: spara %{discount_rate} %',
        month_label: 'Per månad',
        month_sublabel: 'Löpande betalning',
        email: 'E-postadress',
        not_required: '(frivilligt)',
        current_password: 'Aktuellt lösenord',
        new_password: 'Nytt lösenord',
        repeat_new_password: 'Bekräfta nytt lösenord',
        password: 'Lösenord',
        password_confirm: 'Bekräfta lösenord',
        full_name: 'För- och efternamn',
        company: 'Företag',
        street_and_number: 'Adress',
        city: 'Ort',
        zipcode: 'Postnummer',
        country_code: 'Land',
        vat_number: 'Momsregistreringsnummer',
        coupon_code: 'Rabattkod',
        family_name: 'Efternamn',
        given_name: 'Förnamn',
        state_code: 'Stat',
      },
      description: {
        password: 'Välj ett lösenord som innehåller minst 6 tecken',
        vat_number:
          'Vi debiterar 21 procent moms för företag i Nederländerna. Om ditt företag ligger i ett annat EU-land ber vi dig att uppge dina företagsuppgifter och ditt europeiska momsregistreringsnummer för att få en momsfri faktura.\n\nOm ditt företag ligger utanför EU:s skatteområde behöver du fortfarande uppge din faktureringsinformation, men vi debiterar inte moms.',
      },
      error: {
        email: {
          blank: 'Ange e-postadress',
          invalid: 'Ange en giltig e-postadress',
          taken: 'Den här e-postadressen används redan',
          taken_login:
            'Det verkar som om du redan har ett konto. <a class="form-notification__message-link" href="%{login_url}">Logga in?</a>',
        },
        current_password: {
          invalid: 'Vi känner inte igen ditt lösenord',
          blank: 'Ange ditt nuvarande lösenord',
        },
        password: {
          blank: 'Ange ditt nya lösenord',
          too_short: 'Lösenordet måste bestå av minst 6 tecken',
        },
        password_confirm: {
          blank: 'Bekräfta ditt nya lösenord',
          confirm: 'Lösenorden stämmer inte överens',
        },
        full_name: {
          blank: 'Ange för- och efternamn',
          too_short: 'Hoppsan, ditt namn behöver vara minst tre tecken',
        },
        street_and_number: {
          blank: 'Ange adress',
        },
        city: {
          blank: 'Ange ort',
        },
        zipcode: {
          blank: 'Ange postnummer',
        },
        country_code: {
          inclusion:
            'Vi är ganska duktiga på geografi, men känner inte igen det här landet – försök igen',
          blank: 'Ange land',
        },
        vat_number: {
          vat_number: 'Ange ett giltigt momsregistreringsnummer',
        },
        terms_of_service: {
          accepted: 'Du måste godkänna våra användarvillkor för att gå vidare',
        },
        no_results:
          'Vi är ganska duktiga på geografi, men känner inte igen det här landet – försök igen',
        convert: {
          expired:
            'Beklagar, men den här överföringen är inte tillgänglig längre och kan inte sparas. Visste du att WeTransfer Pro-användare kan behålla överföringar så länge de vill? Läs mer här.',
        },
        coupon_code: {
          coupon_code: 'Ange en giltig rabattkod',
        },
        no_state_results: 'Är detta en stat?',
      },
      complete_order: 'Slutför din beställning',
      terms_conditions:
        'Jag godkänner <a href="/legal/terms" %{options}>användarvillkoren</a> och har läst <a href="/legal/privacy" %{options}>sekretess- och cookiemeddelandet</a>',
      signup_for_plus: 'Registrera dig för WeTransfer Pro',
      account_cta: 'Då kör vi',
      signup_for_account: 'Registrera ett WeTransfer-konto',
      'email-verification-not-verified-link':
        'Verifiera din mejladress. Kolla mejlet vi precis skickade eller <button type="button" class="button button--link">begär ett nytt</button>.',
      'email-verification-resend': {
        error: 'Hoppsan, något gick fel',
        info: 'En ny kod har skickats! Kolla din inkorg.',
        info_link: 'Nytt mejl skickat! Kolla inkorgen',
        'throttle-error':
          'Hoppla, nu har vi skickat för många mejl till dig. Vänta %{throttle_time} innan du begär en ny kod.',
      },
      'force-account-verification': {
        message:
          'Verifiera din mejladress så att vi vet att du verkligen är du.',
      },
      marketing_opt_in:
        'Jag vill få nyheter och produktuppdateringar om WeTransfer',
      sso: {
        header: 'Personuppgifter',
        password_reset: {
          button: 'Skicka mejl',
          instructions:
            'Behöver du lite (lösenords-)förändring? Vi förstår. Tryck bara på knappen nedan så skickar vi ett mejl till <span>%{email}</span> med en länk för att ändra ditt lösenord.',
          success: 'Mejlet har skickats! Kolla din inkorg.',
          title: 'Ändra ditt lösenord',
        },
        wrong_user: 'Inte du? Logga ut',
      },
    },
    payment_cancel: {
      submit: 'Bekräfta',
      client_request:
        'En kund bad mig att använda WeTransfer och nu behöver jag det inte längre',
      different_tool: 'Jag hittade ett annat verktyg',
      extra_features: 'Jag behöver extrafunktioner som detta inte erbjuder',
      not_enough_storage: 'Det finns inte tillräckligt med lagringsutrymme',
      not_often_large_files: 'Jag skickar inte stora filer tillräckligt ofta',
      other: 'Annat',
      other_more: 'Kan du berätta mer?',
      skip: 'Hoppa över och avbryt prenumeration',
      temp_project:
        'Jag behöver bara skicka stora filer för ett tillfälligt projekt',
      too_expensive: 'Jag tycker att det är för dyrt',
    },
    payment_cancel_reason: {
      skip: 'Jag vill inte lämna feedback',
    },
    profile: {
      label: {
        profile_title: 'Profilens namn',
        wallpaper_link: 'Webbadress att länka bakgrundsbilder till',
      },
      error: {
        subdomain_name: {
          too_short:
            'Vi gillar också minimalism men ditt WeTransfer-URL måste bestå av minst 2 tecken',
          domain_name: 'Beklagar, men någon har redan knyckt det här namnet',
          invalid:
            'Nej, nu blev det konstigt! Ditt WeTransfer-URL får bara innehålla bokstäver och siffror (och ett bindestreck om det står däremellan).',
          taken: 'Beklagar, men någon har redan knyckt det här namnet',
        },
        subdomain: {
          too_short: 'Fortsätt med minst två tecken',
          too_long: 'Hoppsan, under 63 tecken tack',
          invalid:
            'Nej, nu blev det konstigt! Din WeTransfer-URL får bara innehålla bokstäver och siffror (och ett bindestreck utom i början eller slutet)',
          domain_name: 'Den här URL:en är redan tagen',
        },
        default_recipient_email: {
          invalid: 'Ange en giltig e-postadress',
        },
        wallpaper_link: {
          invalid: 'Ange en giltig webbadress',
        },
      },
      success: {
        subdomain: {
          updated: 'Din URL har uppdaterats',
          available: 'Goda nyheter, den här URL:en är tillgänglig',
        },
      },
      change_background: 'Ladda upp bakgrund',
      delete_avatar: 'Ta bort profilbild',
      delete_background: 'Ta bort bakgrund',
      description: {
        title: 'Psst, begränsa det till 150 tecken så att det ryms på sidan',
        wallpaper_link:
          'Dina bakgrundsbilder kommer att länka till den här webbadressen',
        recipient_email_locked:
          'Filer som skickas genom din profil går bara till den här mejladressen',
      },
      upload_avatar: 'Ladda upp profilbild',
      use_email_background_checkbox_label:
        'Använd den här bakgrundsbilden för alla överföringar som skickas via min profil',
      account_email_checkbox: 'Visa mejladress på profil',
      default_recipient_email_info:
        'Du kan ändra den här mejladressen bland dina <a href="/account">personuppgifter</a>',
      change_subdomain: {
        message:
          'Ändra URL till <a href="%{url}">%{subdomain}.wetransfer.com</a>? Föregående URL blir omedelbart tillgänglig.',
        confirm: 'Ja, ändra URL',
        cancel: 'Gå tillbaka',
      },
    },
    fill_in_password: 'Ange ditt lösenord för att spara ändringarna',
    select_all: 'Markera alla',
    deselect_all: 'Avmarkera alla',
    save_changes: 'Spara ändringar',
    save: 'Spara',
    submitting: 'Skickar in …',
    cancel: 'Avbryt',
    forward: 'Vidarebefordra',
    proceed: 'Fortsätt',
    delete: 'Radera',
    onboarding: {
      placeholder: {
        subdomain_name: 'välj-ett-bra-namn',
      },
      validated: {
        subdomain_name: 'Goda nyheter – den här domänen är ledig',
      },
    },
    confirm_leave:
      'Är du säker på att du vill lämna den här sidan utan att spara dina ändringar?',
    unsaved_changes: 'Lämna sidan? Du förlorar osparade ändringar.',
    contact: {
      add_contact: 'Lägg till kontakt',
      error: {
        email: {
          duplicate: 'Den här e-postadressen finns redan i din kontaktlista',
          invalid: 'Ange en giltig e-postadress',
        },
      },
      label: {
        company: 'Företag',
        email: 'E-postadress',
        name: 'Namn',
      },
    },
    error: {
      current_password: {
        blank: 'Ange ditt nuvarande lösenord',
        invalid: 'Vi känner inte igen ditt lösenord',
      },
      email: {
        blank: 'Ange e-postadress',
        duplicate: 'Den här e-postadressen finns redan i din kontaktlista',
        invalid: 'Ange en giltig e-postadress',
        taken: 'Den här e-postadressen används redan',
      },
    },
    leave: 'Lämna',
    resetpassword: {
      button: {
        request_submit: 'Skicka e-post',
        reset_submit: 'Spara nytt lösenord',
      },
      label: {
        confirm_new_password: 'Bekräfta nytt lösenord',
        email: 'E-postadress',
        new_password: 'Nytt lösenord',
      },
      legend: {
        request_description:
          'Utelåst? Vi skickar instruktioner om hur du återställer ditt lösenord så att du kan komma in igen.',
        request_title: 'Glömt ditt lösenord?',
        reset_description:
          'Ange ett nytt lösenord för att kunna komma in igen.',
        reset_title: 'Ange ett nytt lösenord',
        request_description_success_or_article:
          'Vi har skickat instruktioner till dig om du har ett WeTransfer-konto. Läs mer på <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">Artikel hjälpcenter</a> om du inte har fått något meddelande inom de närmsta minuterna.',
      },
    },
    signin: {
      button: {
        submit: 'Logga in',
      },
      label: {
        email: 'E-postadress',
        password: 'Lösenord',
        remember_me: 'Kom ihåg mig',
      },
      link: {
        forgot_password: 'Glömt lösenord?',
      },
      title: 'Logga in',
    },
    stay_on_page: 'Stanna kvar på sidan',
    close_panel: 'Stäng',
    go_back: 'Gå tillbaka',
    labels: {
      email: 'E-postadress',
    },
    plan: {
      change: {
        month: 'Per månad (%{currency} %{price})',
        title: 'Byt paket',
        year: 'Per år (%{currency} %{price})',
      },
      change_plan: 'Ändra betalningspaket',
      month: {
        copy: 'Löpande betalning',
        label: 'Per månad',
        'label-payment': 'Månadsvis betalning',
        'sub-label': 'En faktura, varje månad',
        title: 'WeTransfer Pro: betalning en gång per månad',
      },
      title: 'Ge dina idéer den förstaklassbehandling de förtjänar',
      year: {
        discount: 'Spara %{rate} % (bra!)',
        'label-payment': 'Årlig betalning',
        'sub-label': 'Du sparar 17 %. Toppen',
        title: 'WeTransfer Pro: betalning en gång per år',
      },
      your_order: 'Ditt köp',
    },
    save_and_continue: 'Spara och fortsätt',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Ange ditt lösenord för att fortsätta',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Inte nu',
        true: 'Öppna i WeTransfer-appen',
      },
      headline: 'Varför inte tänka lite större?',
      headline2: 'Visa filer i appen?',
      subheader: 'Skicka och ta emot 200 GB med WeTransfer Pro',
      subheader2:
        'Visa filer innan du hämtar dem. Skicka och ta emot överföringar, håll koll på hämtningar och få meddelanden.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Förnya nu för att fortsätta utnyttja alla förmåner som ingår i ditt %{tier}-konto',
      account_expired_title_tier: 'Ditt %{tier}-konto har gått ut',
      account_inactive_title_tier: 'Redo för %{tier}',
      account_inactive_action: 'Ja, fortsätt',
      account_inactive_subtitle:
        'Bara ett steg till innan du är klar. Ändrat dig? Det är lugnt—',
      account_inactive_title: 'Är du redo för Pro?',
      account_subscription_action: 'Förläng nu',
      account_subscription_expired: 'Ditt Pro-konto har upphört',
      account_subscription_subtitle:
        'Förläng för att behålla dina överföringar, dina personliga bakgrundsbilder och webbadresser. Om inte så raderas de snart!',
      account_expired_action: 'Förläng nu',
      account_expired_subtitle:
        'Förläng nu för att fortsätta ta del av förmånerna med ditt Pro-abonnemang',
      account_expired_title: 'Ditt Pro-abonnemang har upphört',
      expired_transfer_subtitle:
        'Filerna är varken tillgängliga eller lagrade. Om du inte vill att den här överföringen visas kan du <a>radera den permanent</a> här.',
      expired_transfer_title: 'Den här överföringen är inte tillgänglig längre',
      account_email_verify_logged_out: 'Logga in för att verifiera din mejl',
      account_inactive_sublink: 'annullera din beställning.',
      email_unverified_mobile_cta: 'Redo att verifiera',
      email_unverified_text:
        "Vi skickade en verifieringskod till %{email}. <a href='%{href}'>Inte du?</a>",
      email_unverified_text_link:
        "Vi har skickat ett mejl till %{email}. <a href='%{href}'>Inte du?</a>",
      email_unverified_title: 'Verifiera din mejladress',
      'force-account-verification': {
        body: 'Vi skickar ett mejl med en länk för att se att du verkligen är du.',
      },
      'receiving-email':
        'Obs! Vi har ersatt %{receiving_email} i din profil. Det betyder att nya överföringar bara visas i översikten för dina överföringar om de skickas till %{account_email}. Om du vill ändra det här kan du när som helst uppdatera dina <a href="/account">personuppgifter</a>.',
    },
    design:
      'Du har säkert märkt att vi har ändrat lite saker här på sidan! Många av dem har ändrats till följd av önskemål från våra kunder. Så njut av att utforska den nya och (om vi får säga det själva) förbättrade webbplatsen, och skicka gärna dina kommentarer till oss här.',
    loading_error:
      'Hmm, det verkar som att vi har problem att läsa in den här sidan just nu. \nVi fortsätter försöka, annars kan du <a href="%{path}">försöka att uppdatera den</a> själv.',
    redesign_notice:
      'Du har säkert märkt att vi har <a href="/about/redesign">gjort lite ändringar</a>på webbplatsen! Många av ändringarna är gjorda efter önskemål från er användare. Så klicka runt och utforska den nya och (om vi får säga det själva) förbättrade webbplatsen. Glöm inte att <a href="/contact" rel="external">berätta vad du tycker här<a/>.',
    return_to: 'tillbaka till %{pageName}',
    close: 'Stäng panel',
    cookie: {
      accept: 'Okej',
      text: 'Vi använder kakor. Läs <a href="/legal/terms">allt det där juridiska</a> (inga kakrecept ingår).',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Jobb',
      press: 'Press',
      terms: 'Villkor',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Uppgradera',
    free_limit:
      'Du kan inte skicka mer än 2 GB åt gången. Vill du skicka större överföringar?',
    compare_plans: {
      button: 'Jämför paket',
      text: 'Du kan uppgradera ditt paket för att överföra mer än 2 GB i taget.',
      title: 'Har du fler filer att skicka?',
    },
    mobile: {
      cta: 'Läs mer',
      header: 'Få det mesta ut av WeTransfer',
      upsell_enjoy: 'Du får större lagringsmöjligheter',
      upsell_one: 'Skicka större överföringar',
      upsell_two: 'Anpassa din WeTransfer-sida',
    },
    pro_limit:
      'Du kan inte skicka mer än 2 GB åt gången. Vill du skicka överföringar i alla storlekar?',
  },
  upsell_tiers_one: {
    text: 'Vill du ange lösenord och utgångsdatum för dina överföringar?',
  },
  upsell_tiers_three: {
    text: 'Vill du skicka överföringar till fler än %{email_limit} mejladresser åt gången?',
    title: 'Det ör en för mycket',
  },
  browser: {
    assets_failed: {
      text: 'Vi kunde inte ladda några viktiga delar av vår webbplats.\nDe kan ha blockerats av din brandvägg, proxy eller webbläsarinställning.\nFörsök att uppdatera sidan eller kontakta vårt <a href="https://wetransfer.zendesk.com" rel="external">hjälpcenter</a>.',
      title: 'Oj då …',
    },
    javascript_needed:
      'För att kunna använda WeTransfer måste JavaScript vara aktiverat i din webbläsare',
  },
  languages: {
    en: 'Engelska',
    nl: 'Nederländska',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Skift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'Det här erbjudandet är tillgängligt till %{end_date}. Rabatten gäller på ditt första år av %{user_tier}, varefter prenumerationen förnyas till fullt pris på %{yearly_amount}/%{billing_period}.',
    },
    modal: {
      title: '%{discount_amount} % rabatt på årligt Pro',
      subtitle: 'Rabattkod: %{coupon_code_name}',
      text_content:
        'Det är allt. Det är vårt erbjudande. Vi ger dig en rabatt på %{discount_amount} % på ett årligt Pro-paket.',
      argument: {
        size_limit: 'Skicka och ta emot filöverföringar på 200 GB',
        storage_size: 'Få tillgång till 1 TB lagringsutrymme',
        unlimited_review: 'Skapa obegränsat antal granskningar',
      },
      cta_label: 'Få rabatten',
      dismiss_label: 'Inte nu',
    },
    banner: {
      title:
        'Få %{discount_amount} % rabatt på WeTransfer Pro i ett år – vårt bästa erbjudande hittills',
      cta_label: 'Uppgradera',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Samarbeta på överföringar med %{first_recipient_email}',
      subtitle:
        'Bjud in ditt team att skicka och ta emot överföringar med ditt %{user_plan}-paket.',
      list: {
        overview_item: 'Delad översikt över överföringar',
        storage_limit_item:
          'Delat lagringsutrymme på %{storage_limit} extra per person',
        branding_item: 'Delad varumärkning för team',
        subscription_item: 'Delad prenumeration och fakturering',
      },
      cta: 'Bjud in team',
      dismiss_button: 'Inte idag',
    },
    second_viewing: {
      title: 'Samarbeta på överföringar med ${first_recipient_email}',
      subtitle:
        'Bjud in ditt team att skicka och ta emot överföringar med ditt %{user_plan}-paket.',
      list: {
        overview_item: 'Delad översikt över överföringar',
        storage_limit_item:
          'Delat lagringsutrymme på %{storage_limit} extra per person',
        branding_item: 'Delad varumärkning för team',
        subscription_item: 'Delad prenumeration och fakturering',
      },
      cta: 'Bjud in team',
      dismiss_button: 'Dölj för alltid',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'Ditt konto har uppdaterats',
    update_password: 'Ditt lösenord har uppdaterats',
    update_subscription: 'Ditt betalningspaket har uppdaterats',
    update_profile_success: 'Din profil har uppdaterats',
    link_copied: 'Länken har kopierats till urklipp',
    copy_link_manual:
      'Länk markerad – kopiera den genom att trycka på %{shortcut}',
    delete_transfer_success: 'Den här överföringen har raderats',
    delete_transfers_success: 'Överföringarna har raderats',
    update_expiry_success: 'Tillgänglighetsdatumet har ändrats',
    onboarding_success:
      'Här har du en översikt av överföringar, kontakter, profilinställningar med mera',
    add_contact_success: 'Den här kontakten har lagts till',
    edit_contact_success: 'Den här kontakten har uppdaterats',
    remove_contact_success: 'Den här kontakten har raderats',
    already_signed_in: 'Du är nu inloggad',
    cancel_subscription_success:
      'Så synd att du vill lämna – din prenumeration har annullerats.',
    collect_app_banner_desc:
      'Förhandsgranska, spara och hantera filer från Collect-appen',
    contact_added_confirmation: 'Kontakten lades till i överföringen',
    contact_recipient_locked_text:
      'På den här sidan kan ägaren ta emot filer. Skickar du till någon annan?',
    forward_ready: 'Överföringen är redo att vidarefordras',
    mobile_app_banner_desc: 'Förhandsgranska och spara filer i appen',
    mobile_app_banner_title: 'Spara det i appen',
    reactivate_subscription_success:
      'Välkommen tillbaka! Ditt konto har återaktiverats. ',
    refresh_transfer_upload_lost:
      'Är du säker på att du vill avbryta pågående uppladdning?',
    update_payment_success: 'Ka-bom. Dina betalningsuppgifter har uppdaterats.',
    update_user: 'Dina uppgifter har uppdaterats',
    current_team_notification: 'Du använder %{plan} som %{currentTeam}',
    display_name_updated: 'Titeln har uppdaterats!',
    download_started:
      'Din hämtning har startat. När hämtningen är klar finns filerna på din dator (vanligtvis i mappen Hämtade filer).',
    logged_out:
      'Det verkar som att du har loggats ut från en annan webbläsare. Logga in igen.',
    project_delete:
      'Vill du radera <strong>%{projectName}</strong> och alla filer som du har lagt till där?',
    project_delete_success: '<strong>%{projectName}</strong> har raderats',
    password_changed: 'Lösenordet har ändrats',
    password_removed: 'Lösenordet har tagits bort',
  },
  alert: {
    confirm_cancel_upload_image:
      'Är du säker på att du vill avbryta pågående uppladdning? ',
    cancel_recipient_locked: 'Avbryt',
    cancel_refresh_transfer_upload_lost: 'Nej',
    confirm_refresh_transfer_upload_lost: 'Ja',
    go_to_transfer: 'Gå till överföring',
    redirect_recipient_locked: 'Ja',
    stay: 'Stanna kvar',
    cancel_project_delete: 'Avbryt',
    confirm_project_delete: 'Radera',
  },
  force_update:
    'Spännande saker på gång! <a href="/" onClick=\'javascript:window.location.reload();\'>Uppdatera din webbläsare</a> för att säkerställa att du använder den senaste versionen av WeTransfer.',
  user: {
    already_logged_in:
      'Du är redan inloggad. Är du säker på att du vill återställa ditt lösenord?',
    roles: {
      admin: 'administratör',
      owner: 'ägare',
      user: 'användare',
    },
    sign_out_and_reset: 'Logga ut och återställ ditt lösenord',
  },
  click_here: 'Klicka här',
  cookiebox: {
    notice:
      '<bold>Du är för närvarande inloggad</bold>. När du har rensat dina cookies kommer du att loggas ut. Tidigare överföringar på ditt konto påverkas inte.',
  },
  notice: {
    general_issues:
      'Fungerar det inte som det ska? Vi vet att det är frustrerande men håll ut. Vi får hjulen i rullningen igen <a target="_blank" href=%{link}>så fort det bara går</a>.',
    transfer_issues:
      'Har du problem med din överföring? Vi vet att det är frustrerande men håll ut. Vi får hjulen i rullning igen <a target="_blank" href=%{link}>så fort det bara går</a>.',
    verification:
      'Du, det är dags att <a href="/account">bekräfta din mejl</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Om oss | WeTransfer',
      advertise: 'Annonsera hos oss | WeTransfer',
      apps: 'Gratisappar för Mac, iOS och Android | WeTransfer-appar',
      forgot_password: 'Återställ ditt lösenord | WeTransfer Pro',
      help: 'Hur du skickar stora filer | Hjälp med WeTransfer',
      home: 'Dela stora filer gratis | WeTransfer',
      plus: 'Uppgradera för att skicka större filer | WeTransfer Pro',
      sign_in: 'Logga in | WeTransfer Pro',
      sign_up: 'Registrera dig | WeTransfer Pro',
      upgrade: 'Uppgradera | WeTransfer Pro',
      pricing:
        'Priser | WeTransfer – skicka stora filer och dela bilder online – upp till 2 GB gratis',
    },
    descriptions: {
      help: 'Behöver du teknisk support för WeTransfer? Ta reda på hur du skickar stora filer i vårt snabbhjälpsavsnitt eller kontakta oss.',
      social_help: 'Still haven’t found what you’re looking for?',
    },
  },
  splash: {
    footer: {
      or: 'eller',
      send_files: 'Jag vill skicka stora filer',
      no_thanks: 'Nej tack',
    },
    heading: {
      line_1_free: 'WeTransfer är det bästa sättet att skicka stora filer',
      line_2_free: 'Få ut mer av WeTransfer',
      free_account: 'Välkommen tillbaka. Vill du göra det officiellt?',
    },
    plan: {
      plus: {
        feature_10: 'Anpassa dina mejl',
        feature_11: 'Lagra upp till %{plus_storage_limit}',
        feature_12: 'Bestäm hur länge överföringar ska vara tillgängliga',
        feature_13: 'Lösenordsskydda dina överföringar',
        feature_7: 'Skräddarsy din profil',
        feature_8: 'Skapa din egen adressbok',
        feature_9: 'Anpassa din WeTransfer-webbadress',
      },
      free_account: {
        cta: 'Registrera dig gratis',
        feature_1: 'Ingen lagring',
        feature_2: 'Skicka upp till %{free_transfer_limit}',
        feature_3: 'Radera och skicka överföringar på nytt',
        heading: 'WeTransfer-konto',
        price_label: 'Fri för evigt',
      },
      pro: {
        cta: 'Hämta WeTransfer Pro',
        feature_1: '%{storage_limit_pro} lagring',
        feature_2: 'Skicka och ta emot upp till %{transfer_limit_pro}',
        feature_2_unlimited: 'Skicka och ta emot filer utan storleksgräns',
        feature_3: 'Radera och skicka överföringar på nytt',
        feature_4: 'Lösenordsskydda överföringar',
        feature_5: 'Din egen Pro-sida och URL',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: 'Vill du lägga till %{recipient} i ditt team?',
      text_content:
        'Teammedlemmar kan få åtkomst till varandras överföringar med delat lagringsutrymme och varumärkning. Detta avbryter inte din överföring.',
      cta: 'Nu kör vi',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Länk kopierad',
      copy: 'Kopiera länk',
      copy_again: 'Kopiera igen',
    },
    labels: {
      share: 'Dela den här överföringen',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'PROFFSTIPS',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Testa portals',
        dismiss: 'Inte nu',
        text: 'Du kan bjuda in kunder och medarbetare så att de kan se ditt arbete och välja ut sina favoriter med <strong>portals</strong>. Och ni slipper att mejla fram och tillbaka.',
        title: 'Behöver du få feedback på ditt arbete – riktigt snabbt?',
      },
      'second-viewing': {
        cta: 'Testa portals nu',
        dismiss: 'Visa inte det här igen',
        text: 'Få feedback snabbt och dela nya versioner – allt på en och samma plats. Med <strong>portals</strong> får du ett smidigare arbetsflöde, från granskning till revidering till slutgodkännande.',
        title: 'Du har skickat ditt arbete. Vad händer nu?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Gå till Varumärkesinställningar',
        text_2: 'Vill du lägga till egna videor eller bilder?',
      },
      individual: {
        cta: 'Anpassa sidan',
        text: 'Ge ett gott intryck varje gång någon hämtar dina filer. Lägg till videor eller bilder och välj din egen URL.',
        title: 'Gör ett gott intryck med en egen WeTransfer-sida',
      },
      invitee: {
        cta: 'Jag fattar',
        text_1:
          'Med en egen WeTransfer-sida ger ditt team ett bra intryck varje gång ni delar ert arbete.',
        text_2:
          'Du kan ändra ditt teams bakgrundsbild när du vill under <strong>Varumärkesinställningar</strong>.',
        title: 'Visa upp vad du (och ditt team) gör',
      },
      not_now: 'Inte nu',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Anpassa sidan',
                  premium: {
                    text: 'Vem som helst kan skicka dig överföringar av valfri storlek från ditt teams WeTransfer-sida.',
                  },
                  text: 'Vem som helst kan skicka %{transfer_limit_pro} överföringar från ditt teams WeTransfer-sida',
                },
                premium: {
                  transfer_link: {
                    text: 'Vem som helst kan skicka överföringar till dig oavsett storlek från %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Vem som helst kan skicka upp till %{transfer_limit_pro} överföringar från %{custom_link}',
                },
              },
              premium: {
                text: 'Vem som helst kan skicka överföringar av vilken storlek som helst från ditt teams WeTransfer-sida – ge dem den här länken.',
              },
              regular: {
                cta: 'Jag fattar',
                text: 'Vem som helst kan skicka <strong>%{transfer_limit_pro}</strong> överföringar från ditt teams WeTransfer-sida. Ge dem bara den här länken.',
                title: 'Allt ditt team tar emot på en plats',
              },
            },
            sent: {
              regular: {
                cta: 'Jag fattar',
                text: 'Välkommen till den delade översikten för ditt teams skickade överföringar. Du kan hålla koll på hämtningar, ändra hur länge en överföring ska vara tillgänglig och till och med redigera eller ta bort någon annans överföringar – även om det kan vara schysst att säga till i förväg!',
                title: 'Hantera ditt teams överföringar',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus är nu WeTransfer Pro med 1 TB lagring — det är 10x mer. <a href="/transfers">Se själv!</a>',
  },
  refer_friend: {
    title: 'Värva vänner',
    account: {
      description:
        'Du och en vän får 10 $ vardera när vännen registrerar sig för WeTransfer Pro eller Premium. Dela din värvningslänk och bli belönad med förbetalda kort, välgörenhetsgåvor eller presentkort från våra hundratals partners.',
    },
    window: {
      link: 'Hämta värvningslänk',
      send_another: 'Fortsätt',
      text: 'När en vän registrerar sig för WeTransfer Pro eller Premium får ni båda <strong>10 $</strong>.',
      title: 'Värva en vän',
      title_2: 'för att skicka överföringar.',
    },
    message: {
      success:
        'Det kan man kalla en riktig vän! Registrera dig för WeTransfer Pro eller Premium, så får ni 10 $ vardera i form av ett förbetalt kort, en välgörenhetsgåva eller ett presentkort.',
      self: 'Oj! Den värvningslänken verkar inte stämma. Be din vän om en ny länk så att ni båda får 10 $ när du registrerar dig för WeTransfer Pro eller Premium.',
      fallback:
        'Oj! Den värvningslänken verkar inte stämma. Be din vän om en ny länk så att ni båda får 10 $ när du registrerar dig för WeTransfer Pro eller Premium.',
      expired: 'Din värvningslänk har tyvärr gått ut.',
      dismiss: 'Stäng',
    },
  },
  order_summary: {
    coupon: {
      link: 'Tillämpa kampanjkod',
      input_placeholder: 'Kampanjkod',
      button_label: 'Tillämpa',
      error_message:
        'Tyvärr kan den här koden endast användas för att få rabatt på en prenumerationsperiod på %{billing_period}.',
      generic_error_message:
        'Tyvärr är den här koden inte kompatibel med den här prenumerationen',
      input_error_message: 'Hmm, detta är inte en giltig kod.',
      pill_label: {
        percentage: '-%{percentage}%',
      },
    },
    total: 'Totalt',
  },
  mobile_verify: {
    title: 'Så var det klart',
    subtitle:
      'Din e-post har verifierats – du kan nu använda appen för att skicka och ta emot överföringar.',
    cta: 'Öppna WeTransfer-appen',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Ditt nuvarande paket för <b>%{formattedintervaltotal}</b> /%{subscriptioninterval} förnyas automatiskt den <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Ditt aktuella paket <b>%{formattedTeamWorkspaceCost}</b> /%{subscriptioninterval} <br>(%{membercount} x %{tieramount}) förnyas automatiskt den <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'Ditt nästa betalningsdatum är <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b>/%{interval}',
    team_upgrade_calculation: '(%{membercount} medlemmar x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Ingen storleksgräns på överföringarna',
    premium_feature_two: 'Obegränsat lagringsutrymme',
    premium_feature_three: 'Obegränsade portals och granskningar',
    premium_feature_four:
      'Se <a class="all-benefits-link" href="%{all_benefits_href}">alla förmåner</a>',
    premium_switch_cta_text: 'Byt till Premium',
    pill_text: 'Aktuellt paket',
    member_count: '%{membercount} medlemmar',
    see_all_benefits: 'Se alla förmåner i paketet',
    pending_downgrade_current_subscription:
      'Din prenumeration på arbetsytan har avbrutits och upphör den <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      'Har du ändrat dig? Ingen panik, det är enkelt att komma igång igen.',
    pending_downgrade_reactivate_cta: 'Återaktivera prenumeration',
    pending_downgrade_payment: 'Du har inga kommande betalningar',
    update_payment_cta: 'Uppdatera betalningsuppgifter',
    cancel_plan:
      'Om du avslutar din prenumeration kan du få tillgång till din %{planName}-arbetsyta fram till %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Din arbetsyta kommer då att nedgraderas till gratispaketet och dina befintliga överföringar kommer att löpa ut efter 28 dagar.',
    pending_payment_text:
      'To see your plan and payment information, please complete your payment or cancel your order.',
    learn_more: 'Learn more about plans and pricing',
  },
  time: {
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    remaining: {
      minutes: {
        zero: 'Under a minute remaining',
        one: 'About 1 minute remaining',
        other: 'About %{count} minutes remaining',
      },
      hours: {
        one: 'About an hour remaining',
        other: 'About %{count} hours remaining',
      },
    },
  },
  download: {
    shortcut: 'Press %{command} to see the<br />download progress',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Send up to %{size}',
    progress: {
      busy: 'Transferring...',
    },
    buttons: {
      add: 'Add files',
      transfer: 'Transfer',
      forward: 'Forward',
    },
    forward: {
      done: 'Forward complete',
    },
    friend_email: {
      title: "Friend's email",
      more: 'Add more friends',
    },
    your_email: {
      title: 'Your email',
    },
    message: {
      title: 'Message',
    },
    done: {
      title: 'Transfer complete',
      link: 'Copy your download link:',
      copied: {
        title: 'Copied!',
        text: 'The download link has been copied.',
      },
    },
    more_html: 'Add more files<span>(%{size} left)</span>',
    too_many_recipients:
      "Seems like you've entered too many email addresses. Remember: there's room for up to %{count} people at a time.",
    completed: '%{size} of %{total} completed',
    addresses: {
      one: '%{count} address',
      other: '%{count} addresses',
      remove: 'Do you want to remove %{address} from your previous recipients?',
    },
    ads: {
      plus: {
        title: 'Get more out<br />of WeTransfer<br />with Pro',
        text: "<ul><li>Supersized uploads</li><li>Personalised transfers with your own backgrounds</li><li>Password protected transfers</li><li>Long term storage</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus2: {
        title: 'Impress<br />with your<br />own custom download page',
        text: "<p>Use your own backgrounds and custom WeTransfer URL (yourname.wetransfer.com)<br />to impress your recipients.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus3: {
        title: 'Manage<br />your transfers smarter',
        text: "<p>This transfer is deleted after a week, but with WeTransfer Pro you can store indefinitely, resend and delete instantly, without having to upload again.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus4: {
        title: 'Get extra protection<br />for your files',
        text: "<p>With WeTransfer Pro, you can protect your important and confidential files with a password.</p><p>That way they will never fall into the wrong hands.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      facebook: {
        title: 'Join the<br />WeTransfer<br />community<br />on Facebook',
        text: "<p>Get the latest news, win prizes, discover new artists, read interviews and much more.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Find out more</a></p>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email: 'Sorry, only email is supported when resending a transfer.',
      connect_twitter:
        'Your Twitter account is not yet connected to WeTransfer.',
      connect_facebook:
        'Your Facebook account is not yet connected to WeTransfer.',
      transferproblems: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      limitreached: {
        title: 'Storage Limit',
        text: 'You reached your 1 TB limit. Delete some old transfers to send new files',
      },
      blocked: {
        title: 'Transfer problem',
        text: 'Computer says no. Sorry, but you have been blocked from WeTransfer.',
      },
      upload_error: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      unavailable: {
        title: 'Transfer error',
        text: 'Sorry, this transfer has already been deleted so it cannot be forwarded.',
      },
      startswithdot: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a full stop. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      startswithspace: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a space. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      containsreturn: {
        title: 'Oops',
        text: "One (or more) of your files has a name that contains a return. We don't know quite how you've done that, but it's not going to work. Please rename the file(s), and try adding them again.",
      },
      alreadyinlist: {
        title: 'Yikes',
        text: "Turns out one of your files had the same name as another file that you've already selected. Change it up a little!",
      },
      transfertoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      filetoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      zerobytes: {
        title: 'Whoops',
        text: 'One (or more) of your files is empty or could not be read.',
      },
      ioerror: {
        title: 'Fail',
        text: "One (or more) of your files could not be read or is larger than %{upload_limit}GB. That's not going to fly.",
      },
      filenametoolong: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that is longer than 250 characters. We can't accept filenames longer than this, so please rename it.",
      },
      nofolders: {
        title: 'Uh-oh',
        text: "Sorry, uploading folders doesn't work yet. Try zipping it first.",
      },
      nofiles: {
        title: 'Oops',
        text: "You haven't actually added any files yet.",
      },
      norecipients: {
        title: 'Doh!',
        text: 'Looks like you forgot to enter any email addresses to send to.',
      },
      toomanyrecipients: {
        title: 'Yikes',
        text: 'Too many recipients.',
      },
      bigmessage: {
        title: 'Oops',
        text: 'Your message is longer than a novel. Please make it shorter.',
      },
      nosender: {
        title: 'Seriously?',
        text: 'You forgot to enter your own email address. How could you?',
      },
      senderemailinvalidformat: {
        title: 'Uh-oh',
        text: 'Your email address appears to be incorrect. Mind your spelling!',
      },
      probablynotcopied: {
        title: 'Oops',
        text: "It looks like you haven't copied the link.",
      },
      recipientemailinvalidformat: {
        title: 'Oops',
        text: "You entered one of your friend's email addresses incorrectly.",
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that contains a backslash. We can't accept this, so please rename the files so they don't contain the backslash.",
      },
    },
    tips: {
      maxfilesize_tip: {
        title: 'Tip',
        text: "You can send up to 2GB per transfer. And what's even better: you can transfer as often as you like.",
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Important',
        text: "Your Pro account can send up to 20 GB per transfer, but your browser is preventing this. <a href='/questions/33'>Click here for more information</a>",
      },
      recipients_tip: {
        title: 'Tip',
        text: 'You can enter up to %{email_limit} email addresses to send to. If you just want a download link, click on the share button below.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Tip',
        text: 'Pop your own email address in here so we can contact you when the files have been downloaded.',
      },
      expire_tip: {
        title: 'Tip',
        text: 'You can now change the expiry date of your Pro transfers.',
      },
      message_tip: {
        title: 'Tip',
        text: "Want to send your friends a message along with the files? Here's your chance - but you don’t have to.",
      },
      share_tip: {
        title: 'Tip',
        text: 'Change the way you share your files. Send them by email or grab a download link.',
        text_plus:
          'Change the way you share your files. Send them by email, Twitter, Facebook, or grab a download link.',
      },
      download: {
        title: '',
        chrome:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The download progress should be visible at the bottom of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out how to change this behaviour here</a>.",
        firefox:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in your browser's Download window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        safari:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in the top right corner of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        old_explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. You may also see a security alert at the top of the browser window. <a href='/questions/24' target='_blank'>Find out more</a>.",
        explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible at the bottom of your browser window (you may need to click on Save first), and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        settings:
          'You can change your default download location in your browser settings.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding: 'Forwarding this transfer will clear the form, are you sure?',
    is_busy: "Sorry, we can't do this right now",
  },
  mobile_app: {
    remember_choice: "Don't show this message again",
    uploader: {
      description:
        'Our site is not optimised for mobile right now. But we do have a shiny mobile app.',
      app_name: 'WeTransfer',
      download: 'Download the App',
      continue: 'Continue to WeTransfer.com',
    },
    downloader: {
      title: 'Your files are ready for download!',
      description_ios:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a>" is a pretty good app for that.',
      description_android:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a>" is a pretty good app for that.',
      continue: 'Understood',
    },
  },
};
